/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjcInput from "@grapecity/wijmo.input"
import * as wjrInput from "@grapecity/wijmo.react.input"

import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Container, Row, Col, Card, Button, Table } from "react-bootstrap"
import AlertComponent from "../../../components/AlertComponent"
import ComboBox from "../../../components/ComboBox"
import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../type/wijmoComponents"
import { useEffect, useState, useRef } from "react"
import DateInput from "../../../components/InputWrapper/DateInput"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "../../../globalStore/rootreducer"
import TextInput from "../../../components/InputWrapper/TextInput"
import { T表紙分割 } from "../../../components/ComboBox/HyosiBunkatuComboBox"
import { T請求内訳 } from "../../../components/ComboBox/SeikyuUtiwakeComboBox"
import { 受注配車区分 } from "../../../constant/enum/zyutuHaisya"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import { Form } from "react-bootstrap"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"

import { Prompt, useHistory, useParams } from "react-router-dom"
import { AppDispatch } from "../../.."
import {
  clearAlert,
  setAlerts,
  setWarningAlerts,
} from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import {
  //  TZyutyuHaisyaRegisterListGetReq,
  // TZyutyuHaisyaRegisterListGetReqInner,
  // TZyutyuHaisyaRegisterListGetRes,
  T受注配車入力,
  T品名情報,
  T積卸情報,
  TZyutuHaisyaPutReq,
} from "../../../service/order/zyutyuHaisya/TZyutyuHaisya"
import ZyutyuHaisyaService from "../../../service/order/zyutyuHaisya/zyutyuHaisyaService"
import { 区分分類コード } from "../../../constant/enum/codes"
import RequiredMark from "../../../components/RequiredMark"
import NumberInput from "../../../components/InputWrapper/NumberInput"
import {
  e支払先区分,
  e計上基準日区分,
  e請求車輌区分,
} from "../../../constant/enum/master"
import { T支払先 } from "../../../components/ComboBox/SiharaiSakiComboBox"
import TextAreaInput from "../../../components/InputWrapper/TextAreaInput"
import {
  e工程区分,
  e課税区分,
  e請求支払区分,
  T工程区分値,
} from "../../../constant/enum/zyutuHaisya"
import CONSTANT from "../../../constant"
import { TApiResponse } from "../../../service/TApiResponse"
import ZyomuinSearchModal from "../../../components/SearchModal/ZyomuinSearchModal"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import { showInfoToast } from "../../../components/CustomToast"
import TumiOrosiSakiSearchModal from "../../../components/SearchModal/TumiOrosiSakiSearchModal"
import ZyutyuHaisyaPatternModal from "../ZyutyuHaisyaList/ZyutyuHaisyaPatternModal/ZyutyuHaisyaPatternModal"
import BusyoService from "../../../service/master/busyo/busyoService"
import KubunService from "../../../service/master/kubun/kubunService"
import HinmeiSearchModal from "../../../components/SearchModal/HinmeiSearchModal"
import SyaryoSearchModal from "../../../components/SearchModal/SyaryoSearchModal"
import NinusiSeikyuSearchModal from "../../../components/SearchModal/NinusiSeikyuSearchModal"
import NinusiService from "../../../service/master/ninusi/ninusiService"
import NinusiSeikyuService from "../../../service/master/ninusiseikyu/ninusiSeikyuService"
import RequiredHeader from "../../../components/FlexGridWrapper/RequiredHeader"
import _ from "lodash"
import dayjs from "dayjs"
import SiharaisakiService from "../../../service/master/siharaisaki/siharaisakiService"
import commonUtil from "../../../ts/util/commonUtil"
import ZyutyuHaisyaPatternService from "../../../service/order/zyutyuHaisyaPattern/zyutyuHaisyaPatternService"
import {
  TZyutyuHaisyaPatternListGetRes,
  T受注配車パターン入力,
  T積卸パターン情報,
} from "../../../service/order/zyutyuHaisyaPattern/TZyutyuHaisyaPattern"
import {
  TTumiorosisakiListGetRes,
  T積卸先,
} from "../../../service/master/tumiorosisaki/TTumiorosisaki"
import {
  get品名ItemsSourceByApi,
  get積卸ItemsSourceByApi,
} from "../../../ts/util/autoCompleteUtil"
import { T品名マスタ } from "../../../service/master/hinmei/THinmei"
import {
  getSyaryoItemsSource,
  set配車状態区分By車輌ID,
  同乗者売上計算,
  請求運送料計算,
  SYプロモーション特殊条件合致チェック,
  get乗務員 as get乗務員Inner,
  is請求確認済 as is請求確認済Inner,
} from "../../../ts/util/haisyaUtil"
import Decimal from "decimal.js"
import { TSyaryoModalList } from "../../../service/truck/TSyaryo"
import YosyaSearchModal from "../../../components/SearchModal/YosyaSearchModal"
import { T傭車マスタ } from "../../../service/master/yosya/TYosya"
import AGCKosokuryoSearchModal from "../ZyutyuHaisyaList/AGCKosokuryoSearchModal/AGCKosokuryoSearchModal"
import {
  TNinusiSeikyuListGetRes,
  荷主請求マスタ,
} from "../../../service/master/ninusiseikyu/TNinusiSeikyu"
import constants, { SYプロモーション特殊条件 } from "../../../constant/constant"
import dateUtil from "../../../ts/util/dateUtil"
import BunkatuZyutyuHaisyaService from "../../../service/order/bunkatuZyutyuhaisya/BunkatuZyutyuHaisyaService"
import {
  TBunkatuZyutuHaisyaPostReq,
  TBunkatuZyutyuHaisyaGetRes,
} from "../../../service/order/bunkatuZyutyuhaisya/TBunkatuZyutyuHaisya"
import { TZyomuinListItem } from "../../../service/driver/TZyomuin"
import {
  T品名情報Grid,
  T積卸情報Grid,
  isFirstRow,
  T請求支払情報Grid,
  トレーラ車輛LostFocus,
  車輌GotFocusHandler,
  車輌LostFocusHandler,
  稼働掛率区分コード取得By車輌,
  isSame工程,
  isSame積載品,
  車番validate,
  set車輌情報ByModalInner,
} from "./bunkatuHaisyaUtil"
import EmptyTextHeader from "../../../components/FlexGridWrapper/EmptyTextHeader"

/**
 * 受注配車入力
 * @returns
 */
const BunkatuZyutyuHaisyaRegister = () => {
  const history = useHistory()
  // const location = useLocation()
  const { id: strId } = useParams<{ id: string }>()
  const id =
    strId != null && !isNaN(parseInt(strId)) ? parseInt(strId) : undefined
  const dispatch: AppDispatch = useDispatch()

  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(false)

  // ログインユーザ情報
  const { LoginUserInfo: userInfo } = useSelector(
    (state: RootState) => state.user
  )

  const { yokueigyobiStr: 翌営業日 } = useSelector(
    (state: RootState) => state.date
  )
  const 休日List = useSelector((state: RootState) => state.date.休日List)

  //#region [createCollectionView]

  /**
   * 積卸情報のcollectionView作成
   * @param data
   * @returns
   */
  const create積卸CollectionView = (data?: Partial<T積卸情報>[]) => {
    let addData: Partial<T積卸情報Grid>[] = []
    if (data == null || data.length <= 0) {
      addData.push(
        {
          工程順: 1,
          工程区分コード: e工程区分.積,
          積卸日: 翌営業日,
          row_id: Symbol(),
        },
        {
          工程順: 2,
          工程区分コード: e工程区分.卸,
          積卸日: 翌営業日,
          row_id: Symbol(),
        }
      )
    } else {
      addData.push(
        ...data.map((d) => {
          // 既に積卸日が入っている場合はそのまま使用する
          let 積卸日 = d.積卸日
          if (積卸日 == null || 積卸日 === "") {
            積卸日 = 翌営業日
          }
          return {
            ...d,
            積卸日,
            row_id: Symbol(),
          }
        })
      )
    }

    return new wjCore.CollectionView<T積卸情報Grid>(addData, {
      newItemCreator() {
        const thisCollectionView: wjCore.CollectionView<T積卸情報Grid> = this
        const thisSourceCollection: T積卸情報Grid[] =
          thisCollectionView.sourceCollection

        return {
          row_id: Symbol(),
          積卸日: 翌営業日,
          工程順: thisSourceCollection.length + 1,
        } as unknown as Partial<T積卸情報Grid>
      },
    })
  }

  /**
   * 品名情報のcollectionView作成
   * @param data
   * @returns
   */
  const create品名CollectionView = (data?: Partial<T品名情報>[]) => {
    return new wjCore.CollectionView<T品名情報Grid>(
      data
        ? [
            ...data.map((d) => ({
              ...d,
              row_id: Symbol(),
              品コード:
                d.品コード != null
                  ? d.品コード
                  : d.品名 != null
                  ? CONSTANT.自由入力品コード
                  : undefined,
            })),
          ]
        : [],
      {
        newItemCreator: 品名情報newItemCreator,
      }
    )
  }

  /**
   * 請求支払情報のcollectionView作成
   * @param data
   * @returns
   */
  const create請求支払CollectionView = (
    data?: T受注配車入力 | T受注配車パターン入力
  ) => {
    const 請求情報: T請求支払情報Grid = {
      種別: "請求",
      運送料課税区分コード: data?.請求運送料課税区分コード ?? e課税区分.課税,
      運送料金額: data?.請求運送料 ?? undefined,
      付帯料課税区分コード: data?.請求付帯料課税区分コード ?? e課税区分.課税,
      付帯料金額: data?.請求付帯料 ?? undefined,
      高速料金税込区分コード: data?.請求高速料税込区分コード,
      高速料金額: data?.請求高速料 ?? undefined,
      高速料記号: data?.高速料記号 ?? "",
      AGC高速料マスタID: data?.AGC高速料マスタID ?? undefined,
      備考: data?.請求備考 ?? "",
    }

    const 支払情報: T請求支払情報Grid = {
      種別: "支払",
      運送料課税区分コード: data?.支払運送料課税区分コード ?? e課税区分.課税,
      運送料金額: data?.支払運送料 ?? undefined,
      付帯料課税区分コード: data?.支払付帯料課税区分コード ?? e課税区分.課税,
      付帯料金額: data?.支払付帯料 ?? undefined,
      高速料金税込区分コード: data?.支払高速料税込区分コード,
      高速料金額: data?.支払高速料 ?? undefined,
      備考: data?.支払備考 ?? "",
    }
    return new wjCore.CollectionView<T請求支払情報Grid>([請求情報, 支払情報])
  }
  const 積受注配車運行部所コードRef = useRef<string>()
  const 卸受注配車運行部所コードRef = useRef<string>()
  const pre車番Ref = useRef<string | null>()
  const preトレーラ車番Ref = useRef<string | null>()

  //#endregion
  //#region [state]

  const [isSearching, setIsSearching] = useState(false)
  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()
  // 編集用選択行確保state
  const [選択行, set選択行] = useState<wjcGrid.Row>()

  const [searchResult, setSearchResult] = useState<TBunkatuZyutyuHaisyaGetRes>()
  /**
   * 積受注配車工程ID:卸受注配車工程ID
   */
  const [受注配車工程対応Dictionary, set受注配車工程対応Dictionary] = useState<{
    [name: number]: T積卸情報
  }>({})
  /**
   * 積受注配車積載品ID:卸受注配車積載品ID
   */
  const [積載品対応Dictionary, set積載品対応Dictionary] = useState<{
    [name: number]: T品名情報
  }>({})

  const [受注部所コード, set受注部所コード] = useState<
    T部所マスタ["部所コード"] | null
  >(null)
  const 受注部所コードRef = useRef<T部所マスタ["部所コード"]>()

  const [荷主コード, set荷主コード] = useState<string>()
  const [荷主ID, set荷主ID] = useState<number>()
  const 荷主コードRef = useRef<string>()
  const [荷主名, set荷主名] = useState<string>()
  const [荷主請求ID, set荷主請求ID] = useState<number | null>()
  const [品代端数計算区分コード, set品代端数計算区分コード] = useState<
    string | null
  >()
  const 荷主請求Ref = useRef<number | null>()
  const [荷主請求ItemSource, set荷主請求ItemSource] = useState<T表紙分割[]>()
  const [荷主依頼番号, set荷主依頼番号] = useState<string>()
  const [請求額確認区分名称1, set請求額確認区分名称1] = useState<string>()

  const [受注パターンコード, set受注パターンコード] = useState<string>()
  const [請求区分コード, set請求区分コード] = useState<string | null>()
  const [繰返数, set繰返数] = useState<number>(1)

  const [積卸情報, set積卸情報] = useState<{
    data: wjCore.CollectionView<T積卸情報Grid>
  }>({ data: new wjCore.CollectionView<T積卸情報Grid>() })

  const [工程区分DataMap, set工程区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()
  const [積卸flexGrid, set積卸FlexGrid] = useState<wjcGrid.FlexGrid>()

  const [品名情報, set品名情報] = useState<{
    data: wjCore.CollectionView<T品名情報Grid>
  }>({ data: create品名CollectionView([]) })

  const [単位区分DataMap, set単位区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()
  const [品名flexGrid, set品名FlexGrid] = useState<wjcGrid.FlexGrid>()

  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()
  const [支払先ItemSource, set支払先ItemSource] = useState<T支払先[]>()

  const [請求車番, set請求車番] = useState<string>()

  //#region [積受注配車用項目]
  const [積受注配車配車状態区分コード, set積受注配車配車状態区分コード] =
    useState<string | null>()
  const [積受注配車運行部所コード, set積受注配車運行部所コード] =
    useState<T部所マスタ["部所コード"]>()
  const [積受注配車車輌ID, set積受注配車車輌ID] = useState<number | null>()
  const [積受注配車車番, set積受注配車車番] = useState<string>()
  const [積受注配車車種区分名称, set積受注配車車種区分名称] = useState<string>()
  const [積受注配車最大積載量, set積受注配車最大積載量] = useState<number>()

  const [積受注配車トレーラ車輌ID, set積受注配車トレーラ車輌ID] = useState<
    number | null
  >()
  const [積受注配車トレーラ車番, set積受注配車トレーラ車番] = useState<string>()
  const [積受注配車トレーラ車種区分名称, set積受注配車トレーラ車種区分名称] =
    useState<string>()
  const [積受注配車トレーラ最大積載量, set積受注配車トレーラ最大積載量] =
    useState<number>()

  const [積受注配車乗務員ID, set積受注配車乗務員ID] = useState<number>()
  const [積受注配車乗務員コード, set積受注配車乗務員コード] = useState<string>()
  const [積受注配車乗務員名, set積受注配車乗務員名] = useState<string>()
  const [積受注配車同乗者ID, set積受注配車同乗者ID] = useState<number>()
  const [積受注配車同乗者コード, set積受注配車同乗者コード] = useState<string>()
  const [積受注配車同乗者名, set積受注配車同乗者名] = useState<string>()
  const [積受注配車傭車ID, set積受注配車傭車ID] = useState<number | null>()
  const 積受注配車傭車会社コードRef = useRef<string>()
  const [積受注配車傭車会社コード, set積受注配車傭車会社コード] = useState<
    string | null
  >()
  const [積受注配車乗務員売上, set積受注配車乗務員売上] = useState<number>()
  const [積受注配車乗務員付帯料, set積受注配車乗務員付帯料] = useState<number>()
  const [積受注配車付帯高速料, set積受注配車付帯高速料] = useState<number>()
  const [積ETC, set積ETC] = useState<number>()
  const [積受注配車食事手当, set積受注配車食事手当] = useState<number>()
  const [積受注配車食事手当区分コード, set積受注配車食事手当区分コード] =
    useState<string | null>()
  const [積受注配車稼働掛率区分コード, set積受注配車稼働掛率区分コード] =
    useState<string | null>()
  const [積受注配車同乗者売上, set積受注配車同乗者売上] = useState<number>()
  const [積受注配車同乗者場所コード, set積受注配車同乗者場所コード] = useState<
    string | null
  >()
  const [積受注配車輸送備考, set積受注配車輸送備考] = useState<string>("")
  const [積受注配車特別手当, set積受注配車特別手当] = useState<number>()
  const [積受注配車コース編集, set積受注配車コース編集] = useState<string>()

  //#endregion

  //#region [卸受注配車用項目]
  const [卸受注配車配車状態区分コード, set卸受注配車配車状態区分コード] =
    useState<string | null>()
  const [卸受注配車運行部所コード, set卸受注配車運行部所コード] =
    useState<T部所マスタ["部所コード"]>()
  const [卸受注配車車輌ID, set卸受注配車車輌ID] = useState<number | null>()
  const [卸受注配車車番, set卸受注配車車番] = useState<string>()
  const [卸受注配車車種区分名称, set卸受注配車車種区分名称] = useState<string>()
  const [卸受注配車最大積載量, set卸受注配車最大積載量] = useState<number>()

  const [卸受注配車トレーラ車輌ID, set卸受注配車トレーラ車輌ID] = useState<
    number | null
  >()
  const [卸受注配車トレーラ車番, set卸受注配車トレーラ車番] = useState<string>()
  const [卸受注配車トレーラ車種区分名称, set卸受注配車トレーラ車種区分名称] =
    useState<string>()
  const [卸受注配車トレーラ最大積載量, set卸受注配車トレーラ最大積載量] =
    useState<number>()

  const [卸受注配車乗務員ID, set卸受注配車乗務員ID] = useState<number>()
  const [卸受注配車乗務員コード, set卸受注配車乗務員コード] = useState<string>()
  const [卸受注配車乗務員名, set卸受注配車乗務員名] = useState<string>()
  const [卸受注配車同乗者ID, set卸受注配車同乗者ID] = useState<number>()
  const [卸受注配車同乗者コード, set卸受注配車同乗者コード] = useState<string>()
  const [卸受注配車同乗者名, set卸受注配車同乗者名] = useState<string>()
  const [卸受注配車傭車ID, set卸受注配車傭車ID] = useState<number | null>()
  const 卸受注配車傭車会社コードRef = useRef<string>()
  const [卸受注配車傭車会社コード, set卸受注配車傭車会社コード] = useState<
    string | null
  >()
  const [卸受注配車乗務員売上, set卸受注配車乗務員売上] = useState<number>()
  const [卸受注配車乗務員付帯料, set卸受注配車乗務員付帯料] = useState<number>()
  const [卸受注配車付帯高速料, set卸受注配車付帯高速料] = useState<number>()
  const [卸ETC, set卸ETC] = useState<number>()
  const [卸受注配車食事手当, set卸受注配車食事手当] = useState<number>()
  const [卸受注配車食事手当区分コード, set卸受注配車食事手当区分コード] =
    useState<string | null>()
  const [卸受注配車稼働掛率区分コード, set卸受注配車稼働掛率区分コード] =
    useState<string | null>()
  const [卸受注配車同乗者売上, set卸受注配車同乗者売上] = useState<number>()
  const [卸受注配車同乗者場所コード, set卸受注配車同乗者場所コード] = useState<
    string | null
  >()
  const [卸受注配車輸送備考, set卸受注配車輸送備考] = useState<string>("")
  const [卸受注配車特別手当, set卸受注配車特別手当] = useState<number>()
  const [卸受注配車コース編集, set卸受注配車コース編集] = useState<string>()

  //#endregion

  const [請求額確認区分コード, set請求額確認区分コード] = useState<string>()
  const [請求処理状態区分コード, set請求処理状態区分コード] = useState<string>()

  const [請求計上日, set請求計上日] = useState<string | null | undefined>()
  const [支払計上日, set支払計上日] = useState<string | null | undefined>()

  const [計上基準日区分名称, set計上基準日区分名称] = useState("積日")
  const [計上基準日区分コード, set計上基準日区分コード] = useState<string>()
  const [請求内訳id, set請求内訳id] = useState<number | null>()
  const [請求内訳ItemSource, set請求内訳ItemSource] = useState<T請求内訳[]>()

  const [請求支払情報, set請求支払情報] = useState<{
    data: wjCore.CollectionView<T請求支払情報Grid>
  }>({ data: create請求支払CollectionView() })

  const [課税区分DataMap, set課税区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()
  const [税込区分DataMap, set税込区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()
  const [請求flexGrid, set請求FlexGrid] = useState<wjcGrid.FlexGrid>()

  const [高速料税込区分コード, set高速料税込区分コード] = useState<string>()

  // SYプロモーション用フラグ
  const [積卸先コード変更フラグ, set積卸先コード変更フラグ] = useState(false)
  const [isSY特殊条件, setIsSY特殊条件] = useState(false)
  // 大陽日酸用フラグ
  const [大陽日酸_運送料フラグ, set大陽日酸_運送料フラグ] = useState(false)
  const [大陽小型車距離, set大陽小型車距離] = useState<number>()
  // 荷主検索
  const [is荷主検索Modal, setIs荷主検索Modal] = useState(false)
  // 乗務員検索
  const [is乗務員検索Modal, setIs乗務員検索Modal] = useState(false)
  const [乗務員検索対象, set乗務員検索対象] = useState<"同乗者" | "乗務員">(
    "乗務員"
  )

  // 受注配車パターン検索
  const [is受注配車パターン検索Modal, setIs受注配車パターン検索Modal] =
    useState(false)
  const [モーダル検索用荷主コード, setモーダル検索用荷主コード] = useState<
    string | undefined
  >()
  const [モーダル検索用荷主名, setモーダル検索用荷主名] = useState<
    string | undefined
  >()
  const [select受注部所, setSelect受注部所] = useState<T部所マスタ>()

  // 品名検索
  const [is品名検索Modal, setIs品名検索Modal] = useState(false)

  // 積卸先検索
  const [is積卸先検索Modal, setIs積卸先検索Modal] = useState(false)

  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)
  // 削除確認モーダル
  const [isConfirmDeleteModalShow, setIsConfirmDeleteModalShow] =
    useState(false)

  // 車輌検索
  const [is車輌検索Modal, setIs車輌検索Modal] = useState(false)
  const [is積受注配車検索, setIs受注配車検索] = useState(false)
  const [車輌検索用部所コード, set車輌検索用部所コード] = useState<
    string | undefined
  >()

  const [車輌検索用原動機有無フラグ, set車輌検索用原動機有無フラグ] = useState<
    0 | 1 | undefined
  >()
  // 傭車検索
  const [is傭車検索Modal, setIs傭車検索Modal] = useState(false)

  // エラーチェック用
  const 積卸未存在工程順List = useRef<number[]>([])
  const 積卸時間未存在List = useRef<Symbol[]>([])
  const 複数卸品名未入力List = useRef<number[]>([])
  const 削除対象工程紐づき品名List = useRef<Symbol[]>([])

  //　エラー表示用フラグ
  const [isInvalid荷主コード, setIsInvalid荷主コード] = useState<boolean>(false)
  const [isInvalid表紙名, setIsInvalid表紙名] = useState<boolean>(false)
  const [isInvalid受注部所, setIsInvalid受注部所] = useState<boolean>(false)
  const [isInvalid積受注配車車番, setIsInvalid積受注配車車番] =
    useState<boolean>(false)
  const [isInvalid積受注配車トレーラ車番, setIsInvalid積受注配車トレーラ車番] =
    useState<boolean>(false)
  const [isInvalid卸受注配車車番, setIsInvalid卸受注配車車番] =
    useState<boolean>(false)
  const [isInvalid卸受注配車トレーラ車番, setIsInvalid卸受注配車トレーラ車番] =
    useState<boolean>(false)

  const [isInvalid請求内訳, setIsInvalid請求内訳] = useState<boolean>(false)
  const [isInvalid請求区分, setIsInvalid請求区分] = useState<boolean>(false)
  //
  const isInvalid付帯料 = useRef(false)

  // 車輌のオートフォーカス後の処理
  const [isSyaryoLostFocus, setIsSyaryoLostFocus] = useState<boolean>(false)

  //登録時画面遷移判定用
  const [isPageMove, setIsPageMove] = useState<boolean>(false)

  // 積卸日変更確認用
  const [積卸日isChanged, set積卸日isChanged] = useState<boolean>(false)

  //#endregion

  //#region [comboboxState]

  // 受注部所
  const [受注部所ComboBox, set受注部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [受注部所isLoadEnded, set受注部所isLoadEnded] = useState<boolean>(false)

  // 表紙分割
  const [表紙分割ComboBox, set表紙分割ComboBox] = useState<TWijmoComboBox<
    T表紙分割["荷主請求ID"],
    T表紙分割
  > | null>(null)
  const [表紙分割IsLoadEnded, set表紙分割IsLoadEnded] = useState<boolean>(false)

  // 請求内訳
  const [請求内訳ComboBox, set請求内訳ComboBox] = useState<TWijmoComboBox<
    T請求内訳["荷主請求内訳ID"],
    T請求内訳
  > | null>(null)
  const [請求内訳IsLoadEnded, set請求内訳IsLoadEnded] = useState<boolean>(false)

  // 請求区分
  const [請求区分ComboBox, set請求区分ComboBox] = useState<TWijmoComboBox<
    string,
    T区分マスタ
  > | null>(null)
  const [請求区分isLoadEnded, set請求区分isLoadEnded] = useState<boolean>(false)

  // 稼働掛率区分
  const [稼働掛率ComboBox, set稼働掛率ComboBox] = useState<TWijmoComboBox<
    string,
    T区分マスタ
  > | null>(null)
  const [稼働掛率isLoadEnded, set稼働掛率isLoadEnded] = useState<boolean>(false)

  // AGC高速料
  const [isAGC高速料対象荷主コード, setIsAGC高速料対象荷主コード] =
    useState(false)
  const [isAGC高速料検索Modal, setIsAGC高速料検索Modal] = useState(false)
  const [AGC高速料対象荷主コードList, setAGC高速料対象荷主コードList] =
    useState<string[]>([])

  //#region [積受注配車側用コンボボックス]

  // 配車状態区分
  const [積受注配車配車状態ComboBox, set積受注配車配車状態ComboBox] =
    useState<TWijmoComboBox<string, T区分マスタ> | null>(null)
  const [積受注配車配車状態isLoadEnded, set積受注配車配車状態isLoadEnded] =
    useState<boolean>(false)

  // 運行部所
  const [積受注配車運行部所ComboBox, set積受注配車運行部所ComboBox] =
    useState<TWijmoComboBox<string, T部所マスタ> | null>(null)
  const [積受注配車運行部所isLoadEnded, set積受注配車運行部所isLoadEnded] =
    useState<boolean>(false)

  // 傭車会社
  const [積受注配車傭車会社ComboBox, set積受注配車傭車会社ComboBox] =
    useState<TWijmoComboBox<string, T支払先> | null>(null)
  const [積受注配車傭車会社isLoadEnded, set積受注配車傭車会社isLoadEnded] =
    useState<boolean>(false)

  // 食事手当区分
  const [積受注配車食事手当区分ComboBox, set積受注配車食事手当区分ComboBox] =
    useState<TWijmoComboBox<string, T区分マスタ> | null>(null)
  const [
    積受注配車食事手当区分isLoadEnded,
    set積受注配車食事手当区分isLoadEnded,
  ] = useState<boolean>(false)

  //#endregion

  //#region [卸受注配車側用コンボボックス]

  // 配車状態区分
  const [卸受注配車配車状態ComboBox, set卸受注配車配車状態ComboBox] =
    useState<TWijmoComboBox<string, T区分マスタ> | null>(null)
  const [卸受注配車配車状態isLoadEnded, set卸受注配車配車状態isLoadEnded] =
    useState<boolean>(false)

  // 運行部所
  const [卸受注配車運行部所ComboBox, set卸受注配車運行部所ComboBox] =
    useState<TWijmoComboBox<string, T部所マスタ> | null>(null)
  const [卸受注配車運行部所isLoadEnded, set卸受注配車運行部所isLoadEnded] =
    useState<boolean>(false)

  // 傭車会社
  const [卸受注配車傭車会社ComboBox, set卸受注配車傭車会社ComboBox] =
    useState<TWijmoComboBox<string, T支払先> | null>(null)
  const [卸受注配車傭車会社isLoadEnded, set卸受注配車傭車会社isLoadEnded] =
    useState<boolean>(false)

  // 食事手当区分
  const [卸受注配車食事手当区分ComboBox, set卸受注配車食事手当区分ComboBox] =
    useState<TWijmoComboBox<string, T区分マスタ> | null>(null)
  const [
    卸受注配車食事手当区分isLoadEnded,
    set卸受注配車食事手当区分isLoadEnded,
  ] = useState<boolean>(false)

  //#endregion

  //#region grid操作
  //grid初期化フラグ
  const [積卸GridInitialized, set積卸GridInitialized] = useState<boolean>(false)
  const [品名GridInitialized, set品名GridInitialized] = useState<boolean>(false)
  const [請求支払GridInitialized, set請求支払GridInitialized] =
    useState<boolean>(false)
  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  // 画面初期化フラグ
  const [comboDataInitialized, setComboDataInitialized] = useState(false)
  const [pageInitialized, setPageInitialized] = useState(false)
  // データ読込完了フラグ
  const [getDataFinished, setGetDataFinished] = useState(false)

  //#endregion

  //#endregion

  //#region [method]

  //#region
  /**
   * 品名の情報をキャストします
   */
  const cast品名 = (
    rowItem: T品名情報Grid,
    品名: T品名マスタ | null | undefined
  ) => {
    if (rowItem.品コード !== CONSTANT.自由入力品コード) {
      if (品名 == null) {
        rowItem.荷主品名ID = undefined
        rowItem.品コード = undefined
        rowItem.品名 = undefined
        rowItem.単位区分コード = undefined
      } else {
        rowItem.荷主品名ID = 品名.荷主品名ID
        rowItem.品コード = 品名.品コード
        rowItem.品名 = 品名.品名
        rowItem.単位区分コード = 品名.単位区分コード
        if (荷主コード) {
          set請求内訳id(品名.荷主請求内訳ID)
        }
      }
    } else {
      rowItem.荷主品名ID = undefined
    }
  }

  /**
   * 積卸先の情報をキャストします
   */
  const cast積卸先 = (
    rowItem: T積卸情報Grid,
    積卸先: T積卸先 | undefined | null
  ) => {
    if (積卸先) {
      rowItem.積卸先ID = 積卸先.積卸先ID
      rowItem.積卸先コード = 積卸先.積卸先コード
      rowItem.積卸先名 = 積卸先.積卸先略称
      rowItem.積卸先都道府県 = 積卸先.住所１ ?? ""
      rowItem.積卸先市区町村 = 積卸先.住所２ ?? ""
      rowItem.積卸先番地 = 積卸先.住所３ ?? ""
    } else {
      rowItem.積卸先ID = undefined
      rowItem.積卸先コード = ""
      rowItem.積卸先名 = ""
      rowItem.積卸先都道府県 = ""
      rowItem.積卸先市区町村 = ""
      rowItem.積卸先番地 = ""
    }
  }

  /**
   * 品名情報のnewItemCreator用function
   * 内部でstateを利用しているため function化し、useEffectで付け替えができるように分離
   * @param this
   * @returns
   */
  function 品名情報newItemCreator(this: wjCore.CollectionView<T品名情報Grid>) {
    const thisCollectionView: wjCore.CollectionView<T品名情報Grid> = this
    const thisSourceCollection: T品名情報Grid[] =
      thisCollectionView.sourceCollection
    const 品名max工程順 = _.max(thisSourceCollection.map((s) => s.工程順)) ?? 2
    const 積卸source: T積卸情報Grid[] =
      積卸flexGrid?.collectionView.sourceCollection
    let 工程順 = 品名max工程順
    if (積卸source != null) {
      let 積卸max工程順 = _.max(積卸source.map((s) => s.工程順))
      積卸max工程順 =
        積卸max工程順 != null && 積卸max工程順 > 1 ? 積卸max工程順 : 2
      工程順 = 品名max工程順 <= 積卸max工程順 ? 品名max工程順 : 積卸max工程順
    }
    return {
      row_id: Symbol(),
      工程順,
    }
  }

  const 請求額再計算 = (請求Data: T請求支払情報Grid) => {
    set積受注配車乗務員売上(請求Data.運送料金額 ?? 0)
    if (
      積受注配車同乗者ID != null ||
      (積受注配車同乗者名 != null && 積受注配車同乗者名 !== "") ||
      (積受注配車同乗者コード != null && 積受注配車同乗者コード !== "")
    ) {
      set積受注配車同乗者売上(同乗者売上計算(請求Data.運送料金額 ?? 0))
    }
    set積受注配車乗務員付帯料(請求Data.付帯料金額 ?? 0)
    set積受注配車付帯高速料(請求Data.高速料金額 ?? 0)
  }

  /**
   * 検索
   */
  const search = async (id: number) => {
    setIsSearching(true)
    dispatch(clearAlert()) // アラートを非表示に

    try {
      const bunkatuService = new BunkatuZyutyuHaisyaService()
      const service = new ZyutyuHaisyaService()
      const res = await bunkatuService.get(id)

      setSearchResult(res.data)
      // 積受注配車と卸受注配車の工程と積載品のID対応表を作成
      create対応表(res.data)

      // 共通項目のデータ設定
      if (res.data) {
        // 紐づいたデータに応じて荷主請求と請求内訳を取得し設定する
        const ninusiService = new NinusiSeikyuService()
        const 荷主請求res = await ninusiService.getList({
          荷主Id: res.data.積受注配車.荷主ID,
          削除済み包含フラグ: true,
        })
        if (荷主請求res != null && 荷主請求res.data.length > 0) {
          set荷主請求ItemSource([
            ..._.orderBy(荷主請求res.data, ["荷主コード", "表紙分割コード"]),
          ])

          const 請求内訳Res = await ninusiService.getListUchiwake({
            荷主請求IdList: [...荷主請求res.data.map((d) => d.荷主請求ID)],
          })
          if (請求内訳Res != null && 請求内訳Res.data.length > 0) {
            set請求内訳ItemSource([
              ..._.orderBy(請求内訳Res.data, ["請求内訳コード"]),
            ])
          } else {
            set請求内訳ItemSource([])
          }
        } else {
          set荷主請求ItemSource([])
          set請求内訳ItemSource([])
        }
        // idより紐づくetcデータを取得する
        const etcRes = await service.getEtcKosokuryo({
          受注配車IdList: [
            res.data.積受注配車.荷主ID!,
            res.data.卸受注配車.荷主ID!,
          ],
        })
        if (etcRes && etcRes.data && etcRes.data.length > 0) {
          //高速料を合計した値をetc高速料に埋める
          //MEMO:小数は存在しない前提
          set積ETC(
            _.sum(
              etcRes.data
                .filter((d) => d.受注配車ID === res.data.積受注配車.荷主ID)
                .map((d) => d.高速料 ?? 0)
            )
          )
          set卸ETC(
            _.sum(
              etcRes.data
                .filter((d) => d.受注配車ID === res.data.卸受注配車.荷主ID)
                .map((d) => d.高速料 ?? 0)
            )
          )
        }
        return res
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false)
    }
  }

  const create対応表 = (分割受注配車情報: TBunkatuZyutyuHaisyaGetRes) => {
    const 工程対応Dic: { [name: number]: T積卸情報 } = {}
    const 積載品対応Dic: { [name: number]: T品名情報 } = {}
    // 積受注配車側を基点に回す
    分割受注配車情報.積受注配車.積卸情報.forEach((積受注配車側工程) => {
      const 卸側一致工程 = 分割受注配車情報.卸受注配車.積卸情報.find((工程) =>
        isSame工程(積受注配車側工程, 工程)
      )
      if (卸側一致工程) {
        // 必ずIDは存在する
        工程対応Dic[積受注配車側工程.受注配車工程ID!] = 卸側一致工程
        // 工程に紐づく積載品についても一致を確認し登録
        積受注配車側工程.品名情報.forEach((積受注配車側品名情報) => {
          const 卸側一致品名情報 = 卸側一致工程.品名情報.find((品名情報) =>
            isSame積載品(積受注配車側品名情報, 品名情報)
          )
          if (卸側一致品名情報) {
            //登録できるときは必ずIDが存在する
            積載品対応Dic[積受注配車側品名情報.積載品ID!] = 卸側一致品名情報
          }
        })
      }
    })
    set受注配車工程対応Dictionary(工程対応Dic)
    set積載品対応Dictionary(積載品対応Dic)
  }

  /**
   * 画面の単項目にデータを設定する
   * @param data
   */
  const setData = (data: TBunkatuZyutyuHaisyaGetRes) => {
    //共通項目は積受注配車で設定
    set受注部所コード(data.積受注配車.受注部所コード ?? "")
    荷主コードRef.current = data.積受注配車.荷主コード
    set受注パターンコード(data.積受注配車.受注配車パターンコード)
    set荷主ID(data.積受注配車.荷主ID)
    set荷主コード(data.積受注配車.荷主コード)
    // AGC高速料対象か確認
    if (AGC高速料対象荷主コードList.includes(data.積受注配車.荷主コード)) {
      setIsAGC高速料対象荷主コード(true)
    } else {
      setIsAGC高速料対象荷主コード(false)
    }
    set荷主名(data.積受注配車.荷主名)
    setモーダル検索用荷主コード(data.積受注配車.荷主コード)
    setモーダル検索用荷主名(data.積受注配車.荷主名)
    set荷主請求ID(data.積受注配車.荷主請求ID)
    set品代端数計算区分コード(data.積受注配車.品代端数計算区分コード)
    set荷主依頼番号(data.積受注配車.荷主依頼番号)
    set請求区分コード(data.積受注配車.請求区分コード)
    set請求額確認区分名称1(data.積受注配車.請求額確認区分名称1)
    set繰返数(data.積受注配車.繰返運行数 ?? 1)

    //#region 積受注配車項目
    set積受注配車配車状態区分コード(data.積受注配車.配車状態区分コード)
    set積受注配車傭車ID(data.積受注配車.傭車ID)
    set積受注配車車輌ID(data.積受注配車.車輌ID)
    // 傭車先が設定されていた場合はそちらを表示する
    if (data.積受注配車.傭車ID) {
      set積受注配車車番(data.積受注配車.車番)
      set積受注配車車種区分名称(data.積受注配車.車種区分名称1)
      set積受注配車最大積載量(data.積受注配車.最大積載量)
    } else {
      set積受注配車車番(data.積受注配車.車番)
      set積受注配車車種区分名称(data.積受注配車.車種区分名称1)
      set積受注配車最大積載量(data.積受注配車.最大積載量)
    }
    set積受注配車トレーラ車輌ID(data.積受注配車.トレーラ車輌ID)
    set積受注配車トレーラ車番(data.積受注配車.トレーラ車番)
    set積受注配車トレーラ車種区分名称(data.積受注配車.トレーラ車種区分名称1)
    set積受注配車トレーラ最大積載量(data.積受注配車.トレーラ車種最大積載量)
    set積受注配車稼働掛率区分コード(data.積受注配車.稼働手当車種掛率区分コード)
    set積受注配車運行部所コード(data.積受注配車.運行部所コード ?? "")
    set積受注配車傭車会社コード(data.積受注配車.支払先コード)
    積受注配車傭車会社コードRef.current = data.積受注配車.支払先コード
    set積受注配車乗務員ID(data.積受注配車.乗務員ID)
    set積受注配車乗務員コード(data.積受注配車.乗務員コード)
    set積受注配車乗務員名(data.積受注配車.乗務員名)
    set積受注配車乗務員売上(data.積受注配車.乗務員売上額 ?? undefined)

    set積受注配車乗務員付帯料(data.積受注配車.乗務員付帯料 ?? undefined)
    set積受注配車付帯高速料(data.積受注配車.付帯高速料 ?? undefined)
    set積受注配車特別手当(data.積受注配車.特別手当 ?? undefined)
    set積受注配車同乗者ID(data.積受注配車.同乗者乗務員ID)
    set積受注配車同乗者コード(data.積受注配車.同乗者コード)
    set積受注配車同乗者名(data.積受注配車.同乗者名)
    set積受注配車同乗者場所コード(data.積受注配車.同乗者場所区分コード)
    set積受注配車輸送備考(data.積受注配車.輸送備考 ?? "")
    set積受注配車同乗者売上(data.積受注配車.同乗者売上額)
    set積受注配車食事手当(data.積受注配車.食事手当)
    set積受注配車食事手当区分コード(
      commonUtil.get食事手当コード(区分ItemSource, data.積受注配車.食事手当)
    )
    set積受注配車コース編集(data.積受注配車.コース編集)
    //#endregion 積受注配車項目

    //#region 卸受注配車項目
    set卸受注配車配車状態区分コード(data.卸受注配車.配車状態区分コード)
    set卸受注配車傭車ID(data.卸受注配車.傭車ID)
    set卸受注配車車輌ID(data.卸受注配車.車輌ID)
    // 傭車先が設定されていた場合はそちらを表示する
    if (data.卸受注配車.傭車ID) {
      set卸受注配車車番(data.卸受注配車.車番)
      set卸受注配車車種区分名称(data.卸受注配車.車種区分名称1)
      set卸受注配車最大積載量(data.卸受注配車.最大積載量)
    } else {
      set卸受注配車車番(data.卸受注配車.車番)
      set卸受注配車車種区分名称(data.卸受注配車.車種区分名称1)
      set卸受注配車最大積載量(data.卸受注配車.最大積載量)
    }
    set卸受注配車トレーラ車輌ID(data.卸受注配車.トレーラ車輌ID)
    set卸受注配車トレーラ車番(data.卸受注配車.トレーラ車番)
    set卸受注配車トレーラ車種区分名称(data.卸受注配車.トレーラ車種区分名称1)
    set卸受注配車トレーラ最大積載量(data.積受注配車.トレーラ車種最大積載量)
    set卸受注配車稼働掛率区分コード(data.卸受注配車.稼働手当車種掛率区分コード)
    set卸受注配車運行部所コード(data.卸受注配車.運行部所コード ?? "")
    set卸受注配車傭車会社コード(data.卸受注配車.支払先コード)
    卸受注配車傭車会社コードRef.current = data.卸受注配車.支払先コード

    set卸受注配車乗務員ID(data.卸受注配車.乗務員ID)
    set卸受注配車乗務員コード(data.卸受注配車.乗務員コード)
    set卸受注配車乗務員名(data.卸受注配車.乗務員名)
    set卸受注配車乗務員売上(data.卸受注配車.乗務員売上額 ?? undefined)

    set卸受注配車乗務員付帯料(data.卸受注配車.乗務員付帯料 ?? undefined)
    set卸受注配車付帯高速料(data.卸受注配車.付帯高速料 ?? undefined)
    set卸受注配車特別手当(data.卸受注配車.特別手当 ?? undefined)
    set卸受注配車同乗者ID(data.卸受注配車.同乗者乗務員ID)
    set卸受注配車同乗者コード(data.卸受注配車.同乗者コード)
    set卸受注配車同乗者名(data.卸受注配車.同乗者名)
    set卸受注配車同乗者場所コード(data.卸受注配車.同乗者場所区分コード)
    set卸受注配車輸送備考(data.卸受注配車.輸送備考 ?? "")
    set卸受注配車同乗者売上(data.卸受注配車.同乗者売上額)
    set卸受注配車食事手当(data.卸受注配車.食事手当)
    set卸受注配車食事手当区分コード(
      commonUtil.get食事手当コード(区分ItemSource, data.卸受注配車.食事手当)
    )
    set卸受注配車コース編集(data.卸受注配車.コース編集)
    //#endregion 卸受注配車項目

    set請求内訳id(data.積受注配車.荷主請求内訳ID)
    set請求車番(data.積受注配車.請求車番)
    set支払計上日(data.積受注配車.支払計上日 ?? undefined)

    set請求計上日(data.積受注配車.請求計上日)
    set大陽小型車距離(data.積受注配車.大陽小型車距離)

    set請求額確認区分コード(data.積受注配車.請求額確認区分コード)
    set請求処理状態区分コード(data.積受注配車.請求処理状態区分コード)
    set請求内訳id(data.積受注配車.荷主請求内訳ID)
  }

  const setパターンデータ = async <
    T extends { 受注部所コード?: string; 受注配車パターンコード?: string }
  >(
    condition: T
  ) => {
    // 非同期で設定するため、一旦画面ロック
    set積受注配車コース編集("")
    dispatch(clearAlert())
    // 必須チェック避けのため記述
    // 本来は起こりえない
    if (
      condition.受注部所コード == null ||
      condition.受注部所コード === "" ||
      condition.受注配車パターンコード == null ||
      condition.受注配車パターンコード === ""
    )
      return

    dispatch(画面ロック開始())
    const service = new ZyutyuHaisyaPatternService()
    service
      .getByCode({
        受注部所コード: condition.受注部所コード,
        受注配車パターンコード: condition.受注配車パターンコード,
      })
      .then(async (res) => {
        if (res && res.data) {
          set受注パターンコード(res.data.受注配車パターンコード)
          set受注部所コード(res.data.受注部所コード ?? "")
          set荷主ID(res.data.荷主ID)
          set荷主コード(res.data.荷主コード)
          荷主コードRef.current = res.data.荷主コード

          set荷主名(res.data.荷主略称1)
          set請求区分コード(res.data.請求区分コード)
          set繰返数(res.data.繰返運行数 ?? 1)

          set積卸情報({
            data: create積卸CollectionView(res.data.積卸情報),
          })
          // 品名情報を一覧化する
          let tmp品名情報: T品名情報[] = res.data.積卸情報.flatMap((d) => [
            ...d.品名情報,
          ])
          set品名情報({ data: create品名CollectionView(tmp品名情報) })

          //積側登録
          set積受注配車車輌ID(res.data.車輌ID)
          set積受注配車車番(res.data.車番)
          set積受注配車車種区分名称(res.data.車種区分名称1)
          set積受注配車乗務員ID(res.data.乗務員ID)
          set積受注配車乗務員コード(res.data.乗務員コード)
          set積受注配車乗務員名(res.data.乗務員名)
          set積受注配車同乗者ID(res.data.同乗者乗務員ID)
          set積受注配車同乗者コード(res.data.同乗者コード)
          set積受注配車同乗者名(res.data.同乗者乗務員名)
          set積受注配車トレーラ車輌ID(res.data.トレーラ車輌ID)
          set積受注配車トレーラ車番(res.data.トレーラ車番)
          set積受注配車トレーラ車種区分名称(res.data.トレーラ車種区分名称1)
          set積受注配車稼働掛率区分コード(res.data.稼働手当車種掛率区分コード)
          set積受注配車同乗者場所コード(res.data.同乗場所区分コード)
          set積受注配車運行部所コード(res.data.運行部所コード ?? "")

          set積受注配車食事手当区分コード(
            commonUtil.get食事手当コード(区分ItemSource, res.data.食事手当)
          )

          set積受注配車傭車会社コード(res.data.傭車会社コード)
          //往復のため、パターン値の半額を登録
          const 乗務員売上 = new Decimal(res.data.乗務員売上額 ?? 0)
            .div(2)
            .round()
            .toNumber()
          const 同乗者売上 = new Decimal(res.data.同乗者売上額 ?? 0)
            .div(2)
            .round()
            .toNumber()

          set積受注配車乗務員売上(乗務員売上)
          set積受注配車乗務員付帯料(res.data.乗務員付帯料)
          set積受注配車付帯高速料(res.data.付帯高速料)

          set積受注配車同乗者売上(同乗者売上)
          set積受注配車輸送備考(res.data.輸送備考 ?? "")

          //卸側登録
          set卸受注配車車輌ID(res.data.車輌ID)
          set卸受注配車車番(res.data.車番)
          set卸受注配車車種区分名称(res.data.車種区分名称1)
          set卸受注配車乗務員ID(res.data.乗務員ID)
          set卸受注配車乗務員コード(res.data.乗務員コード)
          set卸受注配車乗務員名(res.data.乗務員名)
          set卸受注配車同乗者ID(res.data.同乗者乗務員ID)
          set卸受注配車同乗者コード(res.data.同乗者コード)
          set卸受注配車同乗者名(res.data.同乗者乗務員名)
          set卸受注配車トレーラ車輌ID(res.data.トレーラ車輌ID)
          set卸受注配車トレーラ車番(res.data.トレーラ車番)
          set卸受注配車トレーラ車種区分名称(res.data.トレーラ車種区分名称1)
          set卸受注配車稼働掛率区分コード(res.data.稼働手当車種掛率区分コード)
          set卸受注配車同乗者場所コード(res.data.同乗場所区分コード)
          set卸受注配車運行部所コード(res.data.運行部所コード ?? "")

          set卸受注配車食事手当区分コード(
            commonUtil.get食事手当コード(区分ItemSource, res.data.食事手当)
          )

          set卸受注配車傭車会社コード(res.data.傭車会社コード)
          set卸受注配車乗務員売上(乗務員売上)
          set卸受注配車同乗者売上(同乗者売上)
          set卸受注配車輸送備考(res.data.輸送備考 ?? "")

          set計上基準日区分名称(res.data.計上基準日区分名称1 ?? "")
          set計上基準日区分コード(res.data.計上基準日区分コード ?? "")

          // パターンから取得した場合は最新の高速料税込区分を取得するために荷主請求IDより検索し埋め込む
          if (res.data.荷主請求ID != null) {
            try {
              const 荷主請求Res = await new NinusiSeikyuService().get(
                res.data.荷主請求ID
              )
              if (荷主請求Res && 荷主請求Res.data) {
                res.data.請求高速料税込区分コード =
                  荷主請求Res.data.高速料税込区分コード
                res.data.支払高速料税込区分コード =
                  荷主請求Res.data.高速料税込区分コード
                set品代端数計算区分コード(
                  荷主請求Res.data.品代端数計算区分コード
                )
              }
            } catch (error) {
              dispatch(setAlerts(error))
            }
          }
          set請求支払情報({
            data: create請求支払CollectionView(res.data),
          })

          // SYプロモーションの特殊条件化のチェックを行う
          setIsSY特殊条件(
            SYプロモーション特殊条件合致チェック({
              荷主コード: res.data.荷主コード,
              車番: res.data.車番,
              乗務員コード: res.data.乗務員コード,
              積卸情報: res.data.積卸情報,
            })
          )

          // createコース編集(積卸flexGrid!)
          set積受注配車コース編集(res.data.コース編集)
          set卸受注配車コース編集(res.data.コース編集)

          return 荷主取得(res.data.荷主コード).then(() => {
            set荷主請求ID(res.data.荷主請求ID)
            set請求内訳id(res.data.荷主請求内訳ID)
          })
        }
      })
      .catch((error) => {
        dispatch(setAlerts(error))
      })
      .finally(() => {
        dispatch(画面ロック解除())
      })
  }

  //#endregion

  //#region [gridMethod]

  const 積卸initializedHandler = (grid: wjcGrid.FlexGrid) => {
    grid.formatItem.addHandler(積卸formatItemHandler)
    grid.beginningEdit.addHandler(積卸beginningEditHandler)
    grid.cellEditEnded.addHandler(積卸CellEditEndedHandler)
    set積卸GridInitialized(true)
    set積卸FlexGrid(grid)
  }

  const 積卸formatItemHandler = (
    f: wjcGrid.FlexGrid,
    e: wjcGrid.FormatItemEventArgs
  ) => {
    if (e.panel === f.cells) {
      if (e.getColumn().binding !== null && e.getRow().dataIndex !== -1) {
        const binding = e.getColumn().binding as keyof T積卸情報Grid
        const dataItem = e.getRow().dataItem as T積卸情報Grid
        if (is請求確認済()) {
          wjCore.toggleClass(e.cell, "read-only-cell", true)
          return
        }
        if (binding === "工程区分コード") {
          wjCore.toggleClass(
            e.cell,
            "read-only-cell",
            isFirstRow(f, dataItem.row_id)
          )
        }

        // 削除フラグ
        if (binding !== "工程順") {
          const row = e.getRow()
          row.isReadOnly = dataItem.削除フラグ === 1
          wjCore.toggleClass(
            e.cell,
            "read-only-cell",
            dataItem.削除フラグ === 1
          )
        }
        if (binding === "積卸日") {
          if (
            積卸時間未存在List.current != null &&
            積卸時間未存在List.current.length > 0
          ) {
            const is未存在 = 積卸時間未存在List.current.find(
              (d) => d === dataItem.row_id
            )
              ? true
              : false
            wjCore.toggleClass(e.cell, "data-warning", is未存在)
          }

          // 休日の場合は色を変更
          wjCore.toggleClass(
            e.cell,
            "date-sunday",
            dateUtil.HolidayCheck(dataItem.積卸日, 休日List) === 1
          )
          wjCore.toggleClass(
            e.cell,
            "date-holiday",
            dateUtil.HolidayCheck(dataItem.積卸日, 休日List) === 2
          )
        }
        if (binding === "工程順") {
          if (
            複数卸品名未入力List.current != null &&
            複数卸品名未入力List.current.length > 0
          ) {
            const is未存在 = 複数卸品名未入力List.current.find(
              (d) => d === e.data
            )
              ? false
              : true
            wjCore.toggleClass(e.cell, "data-warning", is未存在)
          }
        }
      }
    }
  }

  const 積卸beginningEditHandler = (
    f: wjcGrid.FlexGrid,
    e: wjcGrid.CellRangeEventArgs
  ) => {
    if (e.panel === f.cells) {
      const item: T積卸情報Grid = e.getRow().dataItem
      const binding = e.getColumn().binding
      // 工程順1 行程区分区分.積の先頭行の工程と工程Noは編集不可
      if (isFirstRow(f, item.row_id)) {
        if (binding === "工程順" || binding === "工程区分コード") {
          e.cancel = true
          return
        }
      }
      if (is請求確認済()) {
        e.cancel = true
        return
      }
      let col = f.columns[e.col]
      if ("積卸日" === binding && col.editor) {
        const editor = col.editor as wjcInput.InputDate
        editor.calendar.formatItem.removeAllHandlers()
        // 積日と卸日のときはさらに休日も色付け
        editor.calendar.formatItem.addHandler(
          dateUtil.inputDateOffDayFormatHandler(休日List)
        )
      }
    }
  }

  const 積卸CellEditEndedHandler = async (
    f: wjcGrid.FlexGrid,
    e: wjcGrid.CellRangeEventArgs
  ) => {
    let col = f.columns[e.col]
    const item: T積卸情報Grid = e.getRow().dataItem
    const cellData = f.getCellData(e.row, e.col, false)
    const binding = e.getColumn().binding as keyof T積卸情報Grid

    switch (binding) {
      case "工程区分コード":
        // 基本的に積卸一件しかないため、卸が選択されたときに空の場合、積日が入力される
        // 積地が複数ある場合、最も近い前工程Noの積日を取得し入力する。

        if (
          item.積卸日 == null ||
          wjCore.isNullOrWhiteSpace(item.積卸日 ?? "")
        ) {
          if (cellData === e工程区分.卸) {
            const gridData: T積卸情報Grid[] = f.collectionView.sourceCollection
            const 積List = gridData.filter(
              (d) => d.工程区分コード === e工程区分.積
            )
            if (積List.length <= 0) break

            const 積工程順List = 積List
              .filter((a) => a.工程順 != null)
              .map((a) => a.工程順 as number)
            const 現在工程順 = item.工程順
            if (現在工程順 == null) break
            const near積工程No = 積工程順List.reduce((closest, current) => {
              if (現在工程順 - current >= 0 && current > closest) {
                return current
              } else {
                return closest
              }
            }, 0)
            const 積工程 = 積List.find((a) => a.工程順 === near積工程No)
            if (積工程 == null) break
            item.積卸日 = 積工程.積卸日
            f.refresh()
          }
        }
        break
      case "積卸先コード":
        if (col.editor == null) return
        const 積地積卸先Editor = col.editor as wjcInput.AutoComplete
        cast積卸先(
          item,
          積地積卸先Editor.selectedItem as TTumiorosisakiListGetRes
        )
        f.refresh()
        // 積卸先コードの変更を検知する
        set積卸先コード変更フラグ(true)
        break
      case "積卸日":
        // 請求計上日に変更を伝播する
        set積卸日isChanged(true)
        break
      default:
        break
    }
    // 積卸先の情報を編集した際にコース編集を更新
    // 日付はコース編集と無関係のため更新しない
    switch (binding) {
      case "積卸日":
      case "積卸時間":
        break
      default:
        createコース編集(f)
        break
    }
  }

  const 積卸RowEditEndedHandler = (
    f: wjcGrid.FlexGrid,
    e: wjcGrid.CellRangeEventArgs
  ) => {
    let column = 品名flexGrid?.getColumn("工程順")
    if (column) {
      const data: T積卸情報Grid[] = f.collectionView.sourceCollection
      column.dataMap = new wjcGrid.DataMap(
        _.uniq(
          data
            .filter((d) => d.工程区分コード === e工程区分.卸)
            .map((d) => d.工程順)
        )
      )
      column.dataMapEditor = wjcGrid.DataMapEditor.DropDownList
    }
    品名flexGrid?.refresh()
  }

  const 品名initializedHandler = (grid: wjcGrid.FlexGrid) => {
    set品名GridInitialized(true)
    set品名FlexGrid(grid)
  }

  const 品名formatItemHandler = (
    f: wjcGrid.FlexGrid,
    e: wjcGrid.FormatItemEventArgs
  ) => {
    if (e.panel === f.cells) {
      if (e.getColumn().binding !== null && e.getRow().dataIndex !== -1) {
        const dataItem = e.getRow().dataItem as T品名情報Grid
        // 削除フラグ
        const row = e.getRow()
        row.isReadOnly = dataItem.削除フラグ === 1
        wjCore.toggleClass(e.cell, "read-only-cell", dataItem.削除フラグ === 1)
        if (is請求確認済()) {
          wjCore.toggleClass(e.cell, "read-only-cell", true)
          return
        }
        // エラー表示
        const binding = e.getColumn().binding as keyof T品名情報Grid

        switch (binding) {
          case "単価":
          case "運送料":
          case "付帯料":
            const is品数毎 = 請求区分コード === e請求支払区分.品数毎
            wjCore.toggleClass(e.cell, "read-only-cell", !is品数毎)
            if (binding === "付帯料") {
              wjCore.toggleClass(
                e.cell,
                "data-warning",
                isInvalid付帯料.current
              )
            }
            break

          case "工程順":
            let エラー対象: boolean = false
            if (
              積卸未存在工程順List.current != null &&
              積卸未存在工程順List.current.length > 0
            ) {
              エラー対象 = 積卸未存在工程順List.current.find(
                (d) => d === e.data
              )
                ? true
                : false
            }
            if (
              !エラー対象 &&
              削除対象工程紐づき品名List.current != null &&
              削除対象工程紐づき品名List.current.length > 0
            ) {
              エラー対象 = 削除対象工程紐づき品名List.current.find(
                (d) => d === dataItem.row_id
              )
                ? true
                : false
            }
            wjCore.toggleClass(e.cell, "data-warning", エラー対象)
            break
          case "品名":
            wjCore.toggleClass(
              e.cell,
              "read-only-cell",
              dataItem.品コード !== CONSTANT.自由入力品コード
            )
            break
          default:
            break
        }
      }
    }
  }

  const 品名CellEditEndedHandler = async (
    f: wjcGrid.FlexGrid,
    e: wjcGrid.CellRangeEventArgs
  ) => {
    let col = f.columns[e.col]
    const item: T品名情報Grid = e.getRow().dataItem
    const binding = e.getColumn().binding as keyof T品名情報Grid
    const 品名gridData: T品名情報Grid[] = f.collectionView.sourceCollection
    const 請求GridData: T請求支払情報Grid[] =
      請求flexGrid?.collectionView.sourceCollection
    const 請求Data = 請求GridData.find((d) => d.種別 === "請求")

    switch (binding) {
      case "品コード":
        const 品コードEditor = col.editor as wjcInput.AutoComplete
        const selectedItem: T品名マスタ = 品コードEditor.selectedItem
        cast品名(item, selectedItem)
        f.refresh()
        break
      case "単価":
      case "数量":
      case "運送料":
        if (請求区分コード === e請求支払区分.品数毎) {
          if (binding === "単価" || binding === "数量") {
            Decimal.set({
              rounding: Decimal.ROUND_HALF_CEIL,
            })
            const 荷主請求 = 荷主請求ItemSource?.find(
              (i) => i.荷主請求ID === 荷主請求ID
            )
            item.運送料 = 請求運送料計算(item.単価, item.数量, {
              荷主コード: 荷主コードRef.current,
              品コード: item.品コード,
              表紙分割コード: 荷主請求?.表紙分割コード,
              品代端数計算区分コード,
              受注配車パターンコード: 受注パターンコード,
            })
            品名flexGrid?.refresh()
          }

          const 合計運送料 = 品名gridData
            .map((d) => (!d.運送料 ? 0 : d.運送料))
            .reduce((resultData, 運送料) => resultData + 運送料, 0)
          if (請求flexGrid == null) {
            f.refresh()
            break
          }
          if (請求Data) {
            請求Data.運送料金額 = 合計運送料
            請求額再計算(請求Data)
            f.refresh()
            請求flexGrid.refresh()
          }
        }
        break
      case "付帯料":
        const 合計付帯料 = 品名gridData
          .map((d) => (!d.付帯料 ? 0 : d.付帯料))
          .reduce((resultData, 付帯料) => resultData + 付帯料, 0)
        if (請求flexGrid == null) {
          f.refresh()
          break
        }
        if (請求Data) {
          請求Data.付帯料金額 = 合計付帯料
          請求額再計算(請求Data)
          f.refresh()
          請求flexGrid.refresh()
        }
        f.refresh()
        請求flexGrid.refresh()
        break
      default:
        break
    }
    // 積卸先の情報を編集した際にコース編集を更新
    createコース編集(f)
  }

  const 品名beginningEditHandler = (
    f: wjcGrid.FlexGrid,
    e: wjcGrid.CellRangeEventArgs
  ) => {
    let dataItem: T品名情報Grid = e.getRow().dataItem
    let binding = e.getColumn().binding
    if (is請求確認済()) {
      e.cancel = true
      return
    }
    if (binding === "品名") {
      if (dataItem.品コード !== CONSTANT.自由入力品コード) {
        e.cancel = true
        return
      }
    }
    if (請求区分コード !== e請求支払区分.品数毎) {
      switch (binding) {
        case "単価":
        case "運送料":
        case "付帯料":
          e.cancel = true
          break
        default:
          break
      }
    }
  }

  const 品名PastedCellHandler = async (
    f: wjcGrid.FlexGrid,
    e: wjcGrid.CellRangeEventArgs
  ) => {
    const item: T品名情報Grid = e.getRow()?.dataItem
    if (!item) return
    const binding = e.getColumn().binding as keyof T品名情報Grid
    const 品名gridData: T品名情報Grid[] = f.collectionView.sourceCollection
    const 請求GridData: T請求支払情報Grid[] =
      請求flexGrid?.collectionView.sourceCollection
    const 請求Data = 請求GridData.find((d) => d.種別 === "請求")

    switch (binding) {
      case "単価":
      case "数量":
      case "運送料":
        if (請求区分コード === e請求支払区分.品数毎) {
          if (binding === "単価" || binding === "数量") {
            Decimal.set({
              rounding: Decimal.ROUND_HALF_CEIL,
            })
            const 荷主請求 = 荷主請求ItemSource?.find(
              (i) => i.荷主請求ID === 荷主請求ID
            )
            item.運送料 = 請求運送料計算(item.単価, item.数量, {
              荷主コード: 荷主コードRef.current,
              品コード: item.品コード,
              表紙分割コード: 荷主請求?.表紙分割コード,
              品代端数計算区分コード,
              受注配車パターンコード: 受注パターンコード,
            })
            品名flexGrid?.refresh()
          }

          const 合計運送料 = 品名gridData
            .map((d) => (!d.運送料 ? 0 : d.運送料))
            .reduce((resultData, 運送料) => resultData + 運送料, 0)
          if (請求flexGrid == null) {
            f.refresh()
            break
          }
          if (請求Data) {
            請求Data.運送料金額 = 合計運送料
            請求額再計算(請求Data)
            f.refresh()
            請求flexGrid.refresh()
          }
        }
        break
      case "付帯料":
        const 合計付帯料 = 品名gridData
          .map((d) => (!d.付帯料 ? 0 : d.付帯料))
          .reduce((resultData, 付帯料) => resultData + 付帯料, 0)
        if (請求flexGrid == null) {
          f.refresh()
          break
        }
        if (請求Data) {
          請求Data.付帯料金額 = 合計付帯料
          請求額再計算(請求Data)
          f.refresh()
          請求flexGrid.refresh()
        }
        f.refresh()
        請求flexGrid.refresh()
        break
      default:
        break
    }
    // 積卸先の情報を編集した際にコース編集を更新
    createコース編集(f)
  }

  const 請求beginningEditHandler = (
    f: wjcGrid.FlexGrid,
    e: wjcGrid.CellRangeEventArgs
  ) => {
    if (e.panel === f.cells) {
      if (is請求確認済()) {
        e.cancel = true
        return
      }
    }
  }
  const 請求formatItemHandler = (
    f: wjcGrid.FlexGrid,
    e: wjcGrid.FormatItemEventArgs
  ) => {
    if (e.panel === f.cells) {
      if (e.getColumn().binding !== null && e.getRow().dataIndex !== -1) {
        if (is請求確認済()) {
          wjCore.toggleClass(e.cell, "read-only-cell", true)
          return
        } else {
          const binding = e.getColumn().binding as keyof T請求支払情報Grid
          const dataItem: T請求支払情報Grid = e.getRow().dataItem
          switch (binding) {
            case "付帯料金額":
              // 請求付帯料
              if (dataItem.種別 === "請求") {
                wjCore.toggleClass(
                  e.cell,
                  "data-warning",
                  isInvalid付帯料.current
                )
              }
              break
            default:
              break
          }
        }
      }
    }
  }
  const 請求CellEditEndedHandler = async (
    f: wjcGrid.FlexGrid,
    e: wjcGrid.CellRangeEventArgs
  ) => {
    const binding = e.getColumn().binding as keyof T請求支払情報Grid
    const dataItem: T請求支払情報Grid = e.getRow().dataItem

    // 請求のみかつ手入力ではない場合のみ計算する
    if (dataItem.種別 !== "請求") return
    // 積のほうにのみ連動させる
    switch (binding) {
      case "運送料金額":
        set積受注配車乗務員売上(dataItem.運送料金額 ?? 0)

        if (積受注配車同乗者コード != null && 積受注配車同乗者コード !== "") {
          const inner同乗者売上 = new Decimal(dataItem.運送料金額 ?? 0)
            .times(0.5)
            .truncated()
            .toNumber()
          set積受注配車同乗者売上(inner同乗者売上)
        }
        break
      case "付帯料金額":
        // SYプロモーションの特殊条件が一致している場合、乗務員付帯料には付与されない
        !isSY特殊条件 && set積受注配車乗務員付帯料(dataItem.付帯料金額 ?? 0)
        break
      case "高速料金額":
        set積受注配車付帯高速料(dataItem.高速料金額 ?? 0)
        break
      default:
        break
    }
    // 積卸先の情報を編集した際にコース編集を更新
    createコース編集(f)
  }

  //cellEditと同じ処理を行う
  const 請求PastedCellHandler = 請求CellEditEndedHandler

  const 請求initializedHandler = (grid: wjcGrid.FlexGrid) => {
    mergeHeader(grid)
    grid.cellEditEnded.addHandler(請求CellEditEndedHandler)
    grid.pastedCell.addHandler(請求PastedCellHandler)
    set請求支払GridInitialized(true)
    set請求FlexGrid(grid)
  }

  /**
   * ヘッダー結合処理
   */
  const mergeHeader = (grid: wjcGrid.FlexGrid) => {
    // header行に一行追加
    let extraRow = new wjcGrid.Row()
    extraRow.allowMerging = true
    let columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)

    columnHeaders.columns.forEach((c, index) => {
      const binding = c.binding as keyof T請求支払情報Grid
      let setHeaderText = ""
      switch (binding) {
        case "種別":
          setHeaderText = "請求支払"
          break
        case "運送料課税区分コード":
        case "運送料金額":
          setHeaderText = "運送料"
          break
        case "付帯料課税区分コード":
        case "付帯料金額":
          setHeaderText = "付帯料"
          break
        case "高速料金税込区分コード":
        case "高速料金額":
        case "高速料記号":
          setHeaderText = "高速料"
          break
        case "備考":
          setHeaderText = "請求支払備考(付帯作業内容でも使用)"
          break
      }
      c.allowMerging = true
      columnHeaders.setCellData(0, index, setHeaderText)
    })
  }

  //#endregion

  const createコース編集 = (f: wjcGrid.FlexGrid) => {
    const itemsSource = f.itemsSource as wjCore.CollectionView<T積卸情報Grid>
    let sourceCollection =
      itemsSource != null
        ? ([
            ...itemsSource.sourceCollection.filter(
              (a: T積卸情報Grid) => a.削除フラグ !== 1
            ),
          ] as T積卸情報Grid[])
        : undefined
    if (sourceCollection == null) return

    sourceCollection = sourceCollection.sort((a, b) => {
      const a工程順 = a.工程順 ? a.工程順 : 0
      const b工程順 = b.工程順 ? b.工程順 : 0
      const a工程区分 =
        a.工程区分コード != null && a.工程区分コード === e工程区分.卸 ? 1 : 0
      const b工程区分 =
        b.工程区分コード != null && b.工程区分コード === e工程区分.卸 ? 1 : 0
      if (a工程順 - b工程順 === 0) {
        return a工程区分 - b工程区分
      } else {
        return a工程順 - b工程順
      }
    })

    let コース編集Text = ""

    sourceCollection.forEach((s, i) => {
      let text = ` ${s.積卸先名 ?? ""}${s.積卸先名 ? " " : ""}${
        s.積卸先市区町村 ?? ""
      }`
      if (i === 0) {
        コース編集Text += text
      } else {
        if (wjCore.isNullOrWhiteSpace(text)) {
          コース編集Text += text
          return
        }
        if (sourceCollection == null) return
        const preData = sourceCollection[i - 1]
        switch (s.工程区分コード as T工程区分値) {
          case e工程区分.積:
            switch (preData.工程区分コード as T工程区分値) {
              case e工程区分.積:
                text = `/${text}`
                break
              case e工程区分.卸:
                text = `, ${text}`
                break
              default:
                break
            }
            break
          case e工程区分.卸:
            switch (preData.工程区分コード as T工程区分値) {
              case e工程区分.積:
                text = ` ～ ${text}`
                break
              case e工程区分.卸:
                text = `/${text}`
                break
              default:
                break
            }
            break
          default:
            break
        }
        コース編集Text += text
      }
    })
    if (wjCore.isNullOrWhiteSpace(コース編集Text)) return
    set積受注配車コース編集(コース編集Text)
    set卸受注配車コース編集(コース編集Text)
  }

  //#region [submitMethod]

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = async () => {
    clearError()
    let messages: string[] = []
    let isError = false
    // 必須チェック
    const 必須Valid = 必須validate()
    isError = 必須Valid.hasError === true ? true : isError
    messages.push(...必須Valid.messages)

    // 傭車会社が入っていた場合チェックしない
    if (積受注配車傭車会社コード == null || 積受注配車傭車会社コード === "") {
      // 車番存在チェック
      const 車番Valid = await 積受注配車車番validate()
      isError = 車番Valid.hasError === true ? true : isError
      messages.push(...車番Valid.messages)
    }
    if (卸受注配車傭車会社コード == null || 卸受注配車傭車会社コード === "") {
      // 車番存在チェック
      const 車番Valid = await 卸受注配車車番validate()
      isError = 車番Valid.hasError === true ? true : isError
      messages.push(...車番Valid.messages)
    }

    // 工程順チェック
    const 工程順Valid = 工程順validate()
    isError = 工程順Valid.hasError === true ? true : isError
    messages.push(...工程順Valid.messages)

    // 積卸必須チェック
    const 積卸情報Valid = 積卸情報validate()
    isError = 積卸情報Valid.hasError === true ? true : isError
    messages.push(...積卸情報Valid.messages)

    // 複数卸工程必須チェック
    const 複数卸Valid = 複数卸validate()
    isError = 複数卸Valid.hasError === true ? true : isError
    messages.push(...複数卸Valid.messages)

    // 削除対象工程紐づき品名情報存在チェック
    const 削除対象工程紐づき品名情報存在Valid =
      削除対象工程紐づき品名情報存在Validate()
    isError =
      削除対象工程紐づき品名情報存在Valid.hasError === true ? true : isError
    messages.push(...削除対象工程紐づき品名情報存在Valid.messages)

    // 付帯料整合性チェック
    const 付帯料整合性valid = 付帯料整合性Validate()
    isError = 付帯料整合性valid.hasError === true ? true : isError
    messages.push(...付帯料整合性valid.messages)

    if (isError) {
      dispatch(setWarningAlerts(messages))
      積卸flexGrid?.refresh()
      品名flexGrid?.refresh()
      請求flexGrid?.refresh()
      return
    }
    setIsConfirmModalShow(true)
  }

  const clearError = () => {
    dispatch(clearAlert())
    setIsInvalid受注部所(false)
    setIsInvalid荷主コード(false)
    setIsInvalid表紙名(false)
    setIsInvalid積受注配車車番(false)
    setIsInvalid積受注配車トレーラ車番(false)
    setIsInvalid卸受注配車車番(false)
    setIsInvalid卸受注配車トレーラ車番(false)
    setIsInvalid請求内訳(false)
    setIsInvalid請求区分(false)
    isInvalid付帯料.current = false
    積卸未存在工程順List.current = []
    複数卸品名未入力List.current = []
    削除対象工程紐づき品名List.current = []
    積卸flexGrid?.refresh()
    品名flexGrid?.refresh()
    請求flexGrid?.refresh()
  }

  const 必須validate = () => {
    let 必須エラー = false
    const エラーメッセージList: string[] = []

    if (受注部所コード == null || 受注部所コード === "") {
      必須エラー = true
      setIsInvalid受注部所(true)
      エラーメッセージList.push("受注部所は必須入力です")
    }

    if (荷主コード == null || 荷主コード === "") {
      必須エラー = true
      setIsInvalid荷主コード(true)
      エラーメッセージList.push("荷主コードは必須入力です")
    }

    if (荷主請求ID == null || 荷主請求ID === 0) {
      必須エラー = true
      setIsInvalid表紙名(true)
      エラーメッセージList.push("表紙名は必須入力です")
    }

    if (請求内訳id == null || 請求内訳id === 0) {
      必須エラー = true
      setIsInvalid請求内訳(true)
      エラーメッセージList.push("請求内訳は必須入力です")
    }

    if (請求区分コード == null || 請求区分コード === "") {
      必須エラー = true
      setIsInvalid請求区分(true)
      エラーメッセージList.push("請求区分は必須入力です")
    }

    return {
      hasError: 必須エラー,
      messages: エラーメッセージList,
    }
  }

  const 積受注配車車番validate = 車番validate(
    積受注配車車輌ID,
    積受注配車車番,
    set積受注配車車輌ID,
    setIsInvalid積受注配車車番,
    積受注配車トレーラ車輌ID,
    積受注配車トレーラ車番,
    set積受注配車トレーラ車輌ID,
    setIsInvalid積受注配車トレーラ車番,
    積受注配車運行部所コード
  )

  const 卸受注配車車番validate = 車番validate(
    卸受注配車車輌ID,
    卸受注配車車番,
    set卸受注配車車輌ID,
    setIsInvalid卸受注配車車番,
    卸受注配車トレーラ車輌ID,
    卸受注配車トレーラ車番,
    set卸受注配車トレーラ車輌ID,
    setIsInvalid卸受注配車トレーラ車番,
    卸受注配車運行部所コード
  )

  const 積卸情報validate = () => {
    let 積卸情報エラー = false
    const エラーメッセージList: string[] = []
    if (積卸flexGrid == null) {
      return {
        hasError: true,
        messages: ["積卸情報の入力内容が取得できませんでした。"],
      }
    }
    const sourceCollection: T積卸情報Grid[] =
      積卸flexGrid.collectionView.sourceCollection
    sourceCollection.forEach((s) => {
      if (
        s.工程区分コード === e工程区分.積 &&
        (s.積卸日 == null || s.積卸日 === "")
      ) {
        if (!積卸情報エラー) {
          積卸情報エラー = true
          エラーメッセージList.push("積日は必須入力です")
        }
        積卸時間未存在List.current.push(s.row_id)
      }
    })
    return {
      hasError: 積卸情報エラー,
      messages: エラーメッセージList,
    }
  }

  // 品名情報内に積卸情報の工程順に存在しない工程順があった場合エラー
  const 工程順validate = () => {
    if (積卸flexGrid == null || 品名flexGrid == null) {
      return {
        isError: true,
        messages: ["積卸情報と品名情報の入力内容が取得できませんでした。"],
      }
    }
    let hasError = false
    const messages: string[] = []
    const 積卸情報sourceCollection: T積卸情報Grid[] =
      積卸flexGrid.collectionView.sourceCollection
    const 品名情報sourceCollection: T品名情報Grid[] =
      品名flexGrid.collectionView.sourceCollection
    // 卸の工程順のみ設定可能
    const 積卸情報工程順List = _.uniq(
      積卸情報sourceCollection
        .filter((s) => s.工程順 != null && s.工程区分コード === e工程区分.卸)
        .map((s) => s.工程順 as number)
    )

    //削除されるレコードに関してはチェックしない
    const 品名情報工程順List = _.uniq(
      品名情報sourceCollection
        .filter((s) => s.工程順 != null && s.削除フラグ !== 1)
        .map((s) => s.工程順 as number)
    )
    const 未存在工程順List: number[] = []
    品名情報工程順List.forEach((品名工程順) => {
      if (!積卸情報工程順List.includes(品名工程順)) {
        hasError = true
        未存在工程順List.push(品名工程順)
      }
    })

    if (hasError) {
      積卸未存在工程順List.current = [...未存在工程順List]
      品名flexGrid.refresh()
      messages.push(
        "卸情報ではない工程順が割り振られている品名情報が存在します。"
      )
    }
    return {
      hasError,
      messages,
    }
  }

  const 複数卸validate = () => {
    if (積卸flexGrid == null || 品名flexGrid == null) {
      return {
        isError: false,
        messages: [],
      }
    }
    let hasError = false
    const messages: string[] = []
    const 積卸情報sourceCollection: T積卸情報Grid[] =
      積卸flexGrid.collectionView.sourceCollection
    const 品名情報sourceCollection: T品名情報Grid[] =
      品名flexGrid.collectionView.sourceCollection
    const 積卸情報工程順List = _.uniq(
      積卸情報sourceCollection
        .filter(
          (s) =>
            s.工程順 != null &&
            s.工程区分コード === e工程区分.卸 &&
            s.削除フラグ !== 1
        )
        .map((s) => s.工程順 as number)
    )
    const 品名情報工程順List = _.uniq(
      品名情報sourceCollection
        .filter((s) => s.工程順 != null && s.削除フラグ !== 1)
        .map((s) => s.工程順 as number)
    )
    const 未設定工程順List: number[] = []
    積卸情報工程順List.forEach((積卸工程順) => {
      if (!品名情報工程順List.includes(積卸工程順)) {
        hasError = true
        未設定工程順List.push(積卸工程順)
      }
    })

    if (hasError) {
      複数卸品名未入力List.current = [...未設定工程順List]
      品名flexGrid.refresh()
      messages.push("品名情報が割り振られていない工程が存在します。")
    }
    return {
      hasError,
      messages,
    }
  }

  const 削除対象工程紐づき品名情報存在Validate = () => {
    if (積卸flexGrid == null || 品名flexGrid == null) {
      return {
        isError: false,
        messages: [],
      }
    }
    let hasError = false
    const messages: string[] = []
    const 積卸情報sourceCollection: T積卸情報Grid[] =
      積卸flexGrid.collectionView.sourceCollection
    const 品名情報sourceCollection: T品名情報Grid[] =
      品名flexGrid.collectionView.sourceCollection
    const 削除工程順List = _.uniq(
      積卸情報sourceCollection
        .filter((s) => s.削除フラグ === 1)
        .map((s) => s.工程順 as number)
    )

    const 削除対象工程紐づき品名RowIdList = 品名情報sourceCollection
      .filter(
        (s) => s.削除フラグ !== 1 && 削除工程順List.find((n) => n === s.工程順)
      )
      .map((s) => s.row_id)

    hasError = 削除対象工程紐づき品名RowIdList.length > 0 ? true : false
    if (hasError) {
      削除対象工程紐づき品名List.current = [...削除対象工程紐づき品名RowIdList]
      品名flexGrid.refresh()
      messages.push("削除対象の工程に紐づけられている品名情報が存在します。")
    }
    return {
      hasError,
      messages,
    }
  }

  const 付帯料整合性Validate = () => {
    // 請求区分が品数毎のときのみ請求付帯料と品名情報の付帯料の合計が一致しているかチェックを行う
    // SYプロモーションのときは付帯料が特殊条件で足されているため判定しない
    if (請求区分コード !== e請求支払区分.品数毎 || 品名flexGrid == null) {
      return {
        hasError: false,
        messages: [],
      }
    }
    // 請求FlexGridの一行目は請求情報
    const 請求付帯料 = 請求支払情報.data.items[0].付帯料金額 ?? 0
    const 品名付帯料合計 =
      品名情報.data.items.map((i) => i.付帯料 ?? 0).reduce((p, c) => p + c) ?? 0
    if (請求付帯料 !== 品名付帯料合計) {
      isInvalid付帯料.current = true
      return {
        hasError: true,
        messages: ["品名情報の付帯料合計と請求付帯料が一致していません。"],
      }
    }
    return {
      hasError: false,
      messages: [],
    }
  }

  /**
   * 送信
   */
  const submit = async (isMove: boolean) => {
    try {
      const upsertData = await createUpsertData()
      const service = new BunkatuZyutyuHaisyaService()
      let res: TApiResponse<boolean>
      if (id) {
        // 更新
        res = await service.put(id, {
          ...upsertData,
          更新日時: searchResult?.更新日時 ?? "",
        })
      } else {
        // 登録
        res = await service.post(upsertData)
      }
      if (res) {
        isPrompt.current = false
        if (isMove) {
          history.goBack()
        } else {
          commonUtil.goToPageTop()
        }
        showInfoToast(`分割受注配車の${id ? "更新" : "登録"}が完了しました`)
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  /**
   * 入力情報取得
   */
  const createUpsertData = async (): Promise<TBunkatuZyutuHaisyaPostReq> => {
    const 積受注配車工程Data: T積卸情報[] = []
    const 卸受注配車工程Data: T積卸情報[] = []

    // 受注配車工程以下は積と卸は同一になるようにデータを加工する
    // その際元データの一致内容で対応ID表を作り、そのIDと一致するもので更新する
    // TODO:積と卸でデータがずれていた場合を考慮する
    積卸情報.data.items.forEach((工程) => {
      const 卸側積卸情報 = 工程.受注配車工程ID
        ? 受注配車工程対応Dictionary[工程.受注配車工程ID]
        : undefined
      const 品名情報filter: T品名情報Grid[] = 品名情報.data.items.filter(
        (data) => data.工程順 === 工程.工程順
      )

      const upsert積受注配車品名情報: T品名情報[] = []
      const upsert卸受注配車品名情報: T品名情報[] = []

      品名情報filter.forEach((品名情報) => {
        const 品名情報共通部 = {
          荷主品名ID: 品名情報.荷主品名ID,
          品名: 品名情報.品名,
          数量: 品名情報.数量,
          単位区分コード: 品名情報.単位区分コード,
          単価: 品名情報.単価,
          運送料: 品名情報.運送料,
          付帯料: 品名情報.付帯料,
          削除フラグ: 品名情報.削除フラグ,
        }

        upsert積受注配車品名情報.push({
          ...品名情報共通部,
          積載品ID: 品名情報.積載品ID,
          // 品名情報に埋まっているのは積受注配車側なのでそのまま利用
          受注配車工程ID: 品名情報.受注配車工程ID,
          更新日時: 品名情報.更新日時,
        })

        const 卸側品名情報 = 品名情報.積載品ID
          ? 積載品対応Dictionary[品名情報.積載品ID]
          : undefined
        upsert卸受注配車品名情報.push({
          ...品名情報共通部,
          積載品ID: 卸側品名情報?.積載品ID,
          受注配車工程ID: 卸側積卸情報?.受注配車工程ID,
          更新日時: 卸側品名情報?.更新日時,
        })
      })

      const 受注配車工程共通部 = {
        工程順: 工程.工程順,
        工程区分コード: 工程.工程区分コード,
        運行部所コード: 工程.運行部所コード,
        車輌ID: 工程.車輌ID,
        車番: 工程.車番,
        トレーラ車輌ID: 工程.トレーラ車輌ID,
        トレーラ車番: 工程.トレーラ車番,
        乗務員ID: 工程.乗務員ID,
        乗務員名: 工程.乗務員名,
        乗務員食事手当: 工程.乗務員食事手当,
        同乗者乗務員ID: 工程.同乗者乗務員ID,
        同乗者乗務員名: 工程.同乗者乗務員名,
        積卸日: 工程.積卸日,
        積卸時間: 工程.積卸時間,
        積卸先ID: 工程.積卸先ID,
        積卸先名: 工程.積卸先名,
        積卸先都道府県: 工程.積卸先都道府県,
        積卸先市区町村: 工程.積卸先市区町村,
        積卸先番地: 工程.積卸先番地,
        削除フラグ: 工程.削除フラグ,
      }

      積受注配車工程Data.push({
        ...受注配車工程共通部,
        受注配車工程ID: 工程.受注配車工程ID,
        受注配車ID: searchResult?.積受注配車.受注配車ID,
        更新日時: 工程.更新日時,
        品名情報: upsert積受注配車品名情報,
      })

      卸受注配車工程Data.push({
        ...受注配車工程共通部,
        受注配車工程ID: 卸側積卸情報?.受注配車工程ID,
        受注配車ID: 卸側積卸情報?.受注配車ID,
        更新日時: 卸側積卸情報?.更新日時,
        品名情報: upsert卸受注配車品名情報,
      })
    })

    // 受注配車テーブル更新用に積と卸を別々に作る

    const 受注配車共通項目: TZyutuHaisyaPutReq = {
      受注部所コード: 受注部所コード ?? undefined,
      受注配車パターンコード: 受注パターンコード,
      荷主コード: 荷主コード ?? "",
      荷主請求ID: 荷主請求ID ? 荷主請求ID : undefined,
      受注配車区分コード: 受注配車区分.通常貨物,
      表紙分割コード: searchResult?.積受注配車.表紙分割コード,
      表紙名: 荷主請求ID?.toString() ?? undefined,
      荷主依頼番号: 荷主依頼番号,
      輸送備考: 積受注配車輸送備考,
      繰返運行数: 繰返数,
      請求車輌ID: undefined, // 未使用
      請求車番: 請求車番 ?? undefined,
      大陽小型車距離,
      荷主請求内訳ID:
        請求内訳id == null || 請求内訳id === 0 ? undefined : 請求内訳id,
      請求区分コード: 請求区分コード ?? "",
      請求運送料課税区分コード: 請求支払情報.data.items[0].運送料課税区分コード,
      請求運送料: 請求支払情報.data.items[0].運送料金額,
      請求付帯料課税区分コード: 請求支払情報.data.items[0].付帯料課税区分コード,
      請求付帯料: 請求支払情報.data.items[0].付帯料金額,
      請求高速料税込区分コード:
        請求支払情報.data.items[0].高速料金税込区分コード,
      高速料記号: 請求支払情報.data.items[0].高速料記号,
      AGC高速料マスタID: 請求支払情報.data.items[0].AGC高速料マスタID,
      請求高速料: 請求支払情報.data.items[0].高速料金額,
      計上基準日区分コード: 計上基準日区分コード,
      請求計上日: 請求計上日 ?? "",
      請求備考: 請求支払情報.data.items[0].備考,
      支払運送料: 請求支払情報.data.items[1].運送料金額,
      支払付帯料: 請求支払情報.data.items[1].付帯料金額,
      支払高速料: 請求支払情報.data.items[1].高速料金額,
      支払計上日: 支払計上日 ?? undefined,
      支払備考: 請求支払情報.data.items[1].備考,
      コース編集: 積受注配車コース編集,
      更新日時: searchResult?.積受注配車.更新日時,
    }

    const 積受注配車稼働手当車種掛率区分コード =
      await 稼働掛率区分コード取得By車輌(
        積受注配車稼働掛率区分コード,
        積受注配車車輌ID
      )

    const 積受注配車: TZyutuHaisyaPutReq = {
      ...受注配車共通項目,
      受注配車ID: searchResult?.積受注配車.受注配車ID,
      受注伝票番号: searchResult?.積受注配車.受注伝票番号,
      受注枝番: searchResult?.積受注配車.受注枝番 ?? 0,
      配車状態区分コード: set配車状態区分By車輌ID(
        積受注配車配車状態区分コード,
        積受注配車車輌ID
      ),
      輸送備考: 積受注配車輸送備考,
      運行部所コード: 積受注配車運行部所コード ?? "",
      傭車会社コード: 積受注配車傭車会社コード ?? "",
      傭車ID: 積受注配車傭車ID ?? undefined,
      車番: 積受注配車車番,
      車輌ID:
        積受注配車車番 != null && 積受注配車車番 !== "" && 積受注配車車輌ID
          ? 積受注配車車輌ID
          : undefined,
      稼働手当車種掛率区分コード: 積受注配車稼働手当車種掛率区分コード,
      トレーラ車輌ID:
        積受注配車トレーラ車番 != null &&
        積受注配車トレーラ車番 !== "" &&
        積受注配車トレーラ車輌ID
          ? 積受注配車トレーラ車輌ID
          : undefined,
      乗務員ID: 積受注配車乗務員ID ?? undefined,
      乗務員名: 積受注配車乗務員名,
      乗務員売上額: 積受注配車乗務員売上 ?? undefined,
      同乗者売上額: 積受注配車同乗者売上 ?? undefined,
      同乗者ID: 積受注配車同乗者ID ?? undefined,
      同乗者名: 積受注配車同乗者名,
      同乗者場所区分コード: 積受注配車同乗者場所コード ?? "",
      食事手当: 積受注配車食事手当,
      トレーラ車番: 積受注配車トレーラ車番,
      乗務員付帯料: 積受注配車乗務員付帯料,
      付帯高速料: 積受注配車付帯高速料,
      大陽小型車距離,
      コース編集: 積受注配車コース編集,
      更新日時: searchResult?.積受注配車.更新日時,
      積卸情報: 積受注配車工程Data,
    }

    const 卸受注配車稼働手当車種掛率区分コード =
      await 稼働掛率区分コード取得By車輌(
        卸受注配車稼働掛率区分コード,
        卸受注配車車輌ID
      )

    const 卸受注配車: TZyutuHaisyaPutReq = {
      ...受注配車共通項目,
      受注配車ID: searchResult?.卸受注配車.受注配車ID,
      受注伝票番号: searchResult?.卸受注配車.受注伝票番号,
      受注枝番: searchResult?.卸受注配車.受注枝番 ?? 0,
      配車状態区分コード: set配車状態区分By車輌ID(
        卸受注配車配車状態区分コード,
        卸受注配車車輌ID
      ),
      輸送備考: 卸受注配車輸送備考,
      運行部所コード: 卸受注配車運行部所コード ?? "",
      傭車会社コード: 卸受注配車傭車会社コード ?? "",
      傭車ID: 卸受注配車傭車ID ?? undefined,
      車番: 卸受注配車車番,
      車輌ID:
        卸受注配車車番 != null && 卸受注配車車番 !== "" && 卸受注配車車輌ID
          ? 卸受注配車車輌ID
          : undefined,
      稼働手当車種掛率区分コード: 卸受注配車稼働手当車種掛率区分コード,
      トレーラ車輌ID:
        卸受注配車トレーラ車番 != null &&
        卸受注配車トレーラ車番 !== "" &&
        卸受注配車トレーラ車輌ID
          ? 卸受注配車トレーラ車輌ID
          : undefined,
      乗務員ID: 卸受注配車乗務員ID ?? undefined,
      乗務員名: 卸受注配車乗務員名,
      乗務員売上額: 卸受注配車乗務員売上 ?? undefined,
      同乗者売上額: 卸受注配車同乗者売上 ?? undefined,
      同乗者ID: 卸受注配車同乗者ID ?? undefined,
      同乗者名: 卸受注配車同乗者名,
      同乗者場所区分コード: 卸受注配車同乗者場所コード ?? "",
      食事手当: 卸受注配車食事手当,
      トレーラ車番: 卸受注配車トレーラ車番,
      乗務員付帯料: 卸受注配車乗務員付帯料,
      付帯高速料: 卸受注配車付帯高速料,
      大陽小型車距離,
      コース編集: 卸受注配車コース編集,
      更新日時: searchResult?.卸受注配車.更新日時,
      積卸情報: 卸受注配車工程Data,
    }

    return {
      卸受注配車,
      積受注配車,
    }
  }

  //#endregion

  //#region [control用Method]

  const 積受注配車車輛GotFocusHandler = 車輌GotFocusHandler(
    pre車番Ref,
    積受注配車運行部所コードRef,
    積受注配車傭車会社コードRef,
    1
  )

  const 卸受注配車車輛GotFocusHandler = 車輌GotFocusHandler(
    pre車番Ref,
    卸受注配車運行部所コードRef,
    卸受注配車傭車会社コードRef,
    1
  )

  const 積車輌LostFocus = 車輌LostFocusHandler(
    pre車番Ref,
    積受注配車運行部所コードRef,
    積受注配車傭車会社コードRef,
    set積受注配車傭車ID,
    set積受注配車車輌ID,
    set積受注配車車番,
    set積受注配車車種区分名称,
    set積受注配車稼働掛率区分コード,
    set積受注配車最大積載量,
    set積受注配車トレーラ車輌ID,
    set積受注配車トレーラ車番,
    set積受注配車トレーラ車種区分名称,
    set積受注配車トレーラ最大積載量,
    set積受注配車乗務員ID,
    set積受注配車乗務員コード,
    set積受注配車乗務員名,
    setIsSyaryoLostFocus
  )

  const 卸車輌LostFocus = 車輌LostFocusHandler(
    pre車番Ref,
    卸受注配車運行部所コードRef,
    卸受注配車傭車会社コードRef,
    set卸受注配車傭車ID,
    set卸受注配車車輌ID,
    set卸受注配車車番,
    set卸受注配車車種区分名称,
    set卸受注配車稼働掛率区分コード,
    set卸受注配車最大積載量,
    set卸受注配車トレーラ車輌ID,
    set卸受注配車トレーラ車番,
    set卸受注配車トレーラ車種区分名称,
    set卸受注配車トレーラ最大積載量,
    set卸受注配車乗務員ID,
    set卸受注配車乗務員コード,
    set卸受注配車乗務員名,
    setIsSyaryoLostFocus
  )

  const トレーラ車輛GotFocus =
    (運行部所コードRef: React.MutableRefObject<string | undefined>) =>
    (control: wjcInput.AutoComplete) => {
      preトレーラ車番Ref.current = control.text
      control.itemsSourceFunction = getSyaryoItemsSource(運行部所コードRef, 0)
    }

  const 積トレーラ車輛LostFocus = トレーラ車輛LostFocus(
    積受注配車傭車会社コードRef,
    preトレーラ車番Ref,
    積受注配車運行部所コードRef,
    set積受注配車トレーラ車輌ID,
    set積受注配車トレーラ車番,
    set積受注配車トレーラ車種区分名称,
    set積受注配車トレーラ最大積載量,
    setIsSyaryoLostFocus
  )

  const 卸トレーラ車輛LostFocus = トレーラ車輛LostFocus(
    卸受注配車傭車会社コードRef,
    preトレーラ車番Ref,
    卸受注配車運行部所コードRef,
    set卸受注配車トレーラ車輌ID,
    set卸受注配車トレーラ車番,
    set卸受注配車トレーラ車種区分名称,
    set卸受注配車トレーラ最大積載量,
    setIsSyaryoLostFocus
  )

  const 車輌検索ModalClickHandler =
    (
      運行部所コード: string | undefined,
      傭車会社コード: string | null | undefined,
      検索対象フラグ: "積" | "卸",
      原動機有無: 0 | 1
    ) =>
    (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      e.preventDefault()
      setIs受注配車検索(検索対象フラグ === "積")
      set車輌検索用原動機有無フラグ(原動機有無)
      set車輌検索用部所コード(運行部所コード ?? "")
      if (傭車会社コード == null || 傭車会社コード === "") {
        setIs車輌検索Modal(true)
      } else {
        setIs傭車検索Modal(true)
      }
    }

  // パターン検索用
  const getPatternItemsSource =
    (inner受注部所コード: string) =>
    (
      query: string,
      max: number,
      callback: (items: TZyutyuHaisyaPatternListGetRes[]) => void
    ) => {
      if (query == null || wjCore.isNullOrWhiteSpace(query)) {
        callback([])
        return
      } else {
        if (inner受注部所コード == null || inner受注部所コード === "") {
          return []
        }
        const service = new ZyutyuHaisyaPatternService()
        return service
          .getList({
            受注配車パターンコード: query,
            受注部所コード: inner受注部所コード,
          })
          .then((res) => {
            const selectItem = res.data
              ? res.data.map((d) => {
                  let displayName = `${d.受注配車パターンコード ?? ""}`
                  let detailText = ``
                  detailText = commonUtil.addTextWithStartDelimiter(
                    detailText,
                    [d.荷主略称1, d.積地社名, d.卸地社名, d.品名]
                  )
                  if (detailText !== "") {
                    displayName += `: ${detailText}`
                  }
                  return { ...d, displayName }
                })
              : []

            callback(selectItem)
          })
      }
    }

  /**
   * 乗務員フォーカスアウト時の動き
   */
  const 乗務員BlurHandler =
    (
      乗務員コード: string | undefined,
      set乗務員ID: React.Dispatch<React.SetStateAction<number | undefined>>,
      set乗務員コード: React.Dispatch<React.SetStateAction<string | undefined>>,
      set乗務員名: React.Dispatch<React.SetStateAction<string | undefined>>
    ) =>
    async (e: React.FocusEvent<HTMLInputElement>) => {
      if (乗務員コード && 乗務員コード !== "") {
        const inner乗務員 = await get乗務員(乗務員コード)
        set乗務員ID(inner乗務員?.乗務員ID)

        set乗務員コード(inner乗務員?.社員コード)
        set乗務員名(inner乗務員?.社員氏名)
      } else {
        set乗務員ID(undefined)
        set乗務員コード("")
        set乗務員名("")
      }
    }

  const get乗務員 = async (乗務員コード: string) => {
    try {
      return get乗務員Inner(乗務員コード)
    } catch (error) {
      dispatch(setAlerts(error))
    }
    return
  }

  const 積受注配車乗務員BlurHandler = 乗務員BlurHandler(
    積受注配車乗務員コード,
    set積受注配車乗務員ID,
    set積受注配車乗務員コード,
    set積受注配車乗務員名
  )

  const 卸受注配車乗務員BlurHandler = 乗務員BlurHandler(
    卸受注配車乗務員コード,
    set卸受注配車乗務員ID,
    set卸受注配車乗務員コード,
    set卸受注配車乗務員名
  )

  const 同乗者BlurHandler =
    (
      同乗者コード: string | undefined,
      乗務員売上: number | undefined,
      set同乗者ID: React.Dispatch<React.SetStateAction<number | undefined>>,
      set同乗者コード: React.Dispatch<React.SetStateAction<string | undefined>>,
      set同乗者名: React.Dispatch<React.SetStateAction<string | undefined>>,
      set同乗者売上: React.Dispatch<React.SetStateAction<number | undefined>>
    ) =>
    async (e: React.FocusEvent<HTMLInputElement>) => {
      if (同乗者コード == null || 同乗者コード === "") {
        // 同乗者売上をリセット
        set同乗者売上(0)

        set同乗者ID(undefined)
        set同乗者コード("")
        set同乗者名("")
      } else {
        const inner乗務員 = await get乗務員(同乗者コード)
        set同乗者ID(inner乗務員?.乗務員ID)
        set同乗者コード(inner乗務員?.社員コード)
        set同乗者名(inner乗務員?.社員氏名)
        if (inner乗務員) {
          // 同乗者売上をセット
          set同乗者売上(同乗者売上計算(乗務員売上))
        } else {
          set同乗者売上(0)
        }
      }
    }

  const 積受注配車同乗者BlurHandler = 同乗者BlurHandler(
    積受注配車同乗者コード,
    積受注配車乗務員売上,
    set積受注配車同乗者ID,
    set積受注配車同乗者コード,
    set積受注配車同乗者名,
    set積受注配車同乗者売上
  )

  const 卸受注配車同乗者BlurHandler = 同乗者BlurHandler(
    卸受注配車同乗者コード,
    卸受注配車乗務員売上,
    set卸受注配車同乗者ID,
    set卸受注配車同乗者コード,
    set卸受注配車同乗者名,
    set卸受注配車同乗者売上
  )

  const on卸車番変更ボタンClickHandler: React.MouseEventHandler<
    HTMLButtonElement
  > = (e) => {
    e.stopPropagation()
    e.preventDefault()
    // ボタンクリックで卸側の請求車番に変更
    if (請求内訳id) {
      const 荷主請求内訳 = 請求内訳ItemSource?.find(
        (i) => i.荷主請求内訳ID === 請求内訳id
      )
      if (荷主請求内訳) {
        switch (荷主請求内訳.請求車輌区分コード) {
          case e請求車輌区分.ヘッド:
            set請求車番(卸受注配車車番)
            break
          case e請求車輌区分.トレーラー:
            set請求車番(卸受注配車トレーラ車番)
            break
          default:
            break
        }
      }
    }
  }

  //#endregion

  /**
   * 請求額確認
   */
  const is請求確認済 = () =>
    is請求確認済Inner({
      請求額確認区分コード,
      請求処理状態区分コード,
    })

  //#region [modalMethod]

  const set荷主ByModal = async (荷主: 荷主請求マスタ) => {
    荷主コードRef.current = 荷主.荷主コード
    荷主請求Ref.current = 荷主.荷主請求ID
    await 荷主取得(荷主.荷主コード)
    set荷主請求ID(荷主.荷主請求ID)
    set高速料税込区分コード(荷主.高速料税込区分コード)
    set品代端数計算区分コード(荷主.品代端数計算区分コード)
    set荷主コード(荷主.荷主コード)
    set荷主名(荷主.荷主略称1)
  }

  /**
   * 乗務員モーダルからの設定値で値を更新
   */
  const set乗務員ByModal = (乗務員: TZyomuinListItem) => {
    let set乗務員ID = set積受注配車乗務員ID
    let set乗務員名 = set積受注配車乗務員名
    let set乗務員コード = set積受注配車乗務員コード
    if (!is積受注配車検索) {
      if (乗務員検索対象 !== "同乗者") {
        set乗務員ID = set卸受注配車乗務員ID
        set乗務員名 = set卸受注配車乗務員名
        set乗務員コード = set卸受注配車乗務員コード
      } else {
        set乗務員ID = set卸受注配車同乗者ID
        set乗務員名 = set卸受注配車同乗者名
        set乗務員コード = set卸受注配車同乗者コード
      }
    } else if (乗務員検索対象 === "同乗者") {
      set乗務員ID = set積受注配車同乗者ID
      set乗務員名 = set積受注配車同乗者名
      set乗務員コード = set積受注配車同乗者コード
    }

    set乗務員ID(乗務員.乗務員ID)
    set乗務員名(乗務員.社員氏名)
    set乗務員コード(乗務員.社員コード)

    switch (乗務員検索対象) {
      case "同乗者":
        // 同乗者売上をセット

        is積受注配車検索
          ? set積受注配車同乗者売上(同乗者売上計算(積受注配車乗務員売上))
          : set卸受注配車同乗者売上(同乗者売上計算(卸受注配車乗務員売上))
        break
      default:
        break
    }
  }

  const set傭車ByModal = (傭車: T傭車マスタ) => {
    if (is積受注配車検索) {
      // 傭車が設定される場合、車輌は傭車側となる
      set積受注配車傭車ID(傭車.傭車ID)
      set積受注配車車番(傭車.車番)
      set積受注配車車種区分名称(傭車.車種区分名称1)
      // 乗務員も変更される
      // そのため乗務員IDを削除する
      set積受注配車乗務員ID(undefined)
      set積受注配車乗務員コード(undefined)
      set積受注配車乗務員名(傭車.乗務員名)
    } else {
      // 傭車が設定される場合、車輌は傭車側となる
      set卸受注配車傭車ID(傭車.傭車ID)
      set卸受注配車車番(傭車.車番)
      set卸受注配車車種区分名称(傭車.車種区分名称1)
      // 乗務員も変更される
      // そのため乗務員IDを削除する
      set卸受注配車乗務員ID(undefined)
      set卸受注配車乗務員コード(undefined)
      set卸受注配車乗務員名(傭車.乗務員名)
    }
  }

  const set積受注配車車輌情報ByModalInner = set車輌情報ByModalInner(
    車輌検索用原動機有無フラグ,
    set積受注配車車輌ID,
    set積受注配車車番,
    set積受注配車車種区分名称,
    set積受注配車最大積載量,
    set積受注配車トレーラ車輌ID,
    set積受注配車トレーラ車番,
    set積受注配車トレーラ車種区分名称,
    set積受注配車トレーラ最大積載量,
    set積受注配車乗務員ID,
    set積受注配車乗務員コード,
    set積受注配車乗務員名,
    set積受注配車稼働掛率区分コード
  )
  const set卸受注配車車輌情報ByModalInner = set車輌情報ByModalInner(
    車輌検索用原動機有無フラグ,
    set卸受注配車車輌ID,
    set卸受注配車車番,
    set卸受注配車車種区分名称,
    set卸受注配車最大積載量,
    set卸受注配車トレーラ車輌ID,
    set卸受注配車トレーラ車番,
    set卸受注配車トレーラ車種区分名称,
    set卸受注配車トレーラ最大積載量,
    set卸受注配車乗務員ID,
    set卸受注配車乗務員コード,
    set卸受注配車乗務員名,
    set卸受注配車稼働掛率区分コード
  )
  /**
   * 車輌モーダルより入力された値を登録
   */
  const set車輌情報ByModal = (車輌: TSyaryoModalList) => {
    if (is積受注配車検索) {
      set積受注配車車輌情報ByModalInner(車輌)
    } else {
      set卸受注配車車輌情報ByModalInner(車輌)
      return
    }

    // 積受注配車のときのみ請求車番を設定する
    if (!請求内訳id) return

    const 請求内訳 = 請求内訳ItemSource?.find(
      (i) => i.荷主請求内訳ID === 請求内訳id
    )
    if (!請求内訳) return

    switch (車輌検索用原動機有無フラグ) {
      case 1:
        if (請求内訳.請求車輌区分コード === e請求車輌区分.ヘッド) {
          set請求車番(車輌.車番)
        } else if (請求内訳.請求車輌区分コード === e請求車輌区分.トレーラー) {
          set請求車番(積受注配車トレーラ車番)
        } else {
          set請求車番(undefined)
        }
        break
      case 0:
        if (請求内訳.請求車輌区分コード === e請求車輌区分.ヘッド) {
          set請求車番(積受注配車車番)
        } else if (請求内訳.請求車輌区分コード === e請求車輌区分.トレーラー) {
          set請求車番(車輌.車番)
        } else {
          set請求車番(undefined)
        }
        break

      default:
        break
    }
  }

  //#endregion

  /**
   * 削除
   */
  const deleteZyutyuHaisya = async () => {
    try {
      const service = new ZyutyuHaisyaService()
      let res: TApiResponse<boolean>
      res = await service.delete({
        受注配車ID: searchResult!.積受注配車.受注配車ID!,
        更新日時: searchResult!.積受注配車.更新日時!,
      })
      if (res) {
        isPrompt.current = false
        history.goBack()
        showInfoToast(`受注配車の削除が完了しました`)
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsConfirmDeleteModalShow(false)
    }
  }

  const AGC高速料Clear = () => {
    const 請求GridData: T請求支払情報Grid[] =
      請求flexGrid?.collectionView.sourceCollection
    const 請求Data = 請求GridData.find((d) => d.種別 === "請求")
    if (請求Data) {
      請求Data.AGC高速料マスタID = undefined
      請求Data.高速料記号 = ""

      //金額は変えないため、再計算は行わない
      // 請求額再計算(請求Data)
      請求flexGrid?.refresh()
    }
  }

  //#endregion

  //#region [effect]
  // 初期設定
  useEffect(() => {
    dispatch(画面ロック開始())
    Promise.all([
      new BusyoService().getList({}),
      new KubunService().getList(),
      new SiharaisakiService().getList({
        支払先区分コード: e支払先区分.傭車先,
      }),
    ]).then(([部所ListRes, 区分マスタRes, 傭車マスタRes]) => {
      set部所ItemSource(部所ListRes.data)

      set区分ItemSource(区分マスタRes.data)
      set支払先ItemSource(傭車マスタRes.data)
      set工程区分DataMap(
        new wjcGrid.DataMap<T区分マスタ>(
          区分マスタRes.data.filter(
            (d) =>
              d.分類コード === 区分分類コード.受注配車_請求支払.工程区分 &&
              // 積卸のみ表示のため、区分コードの"1"開始のみ抽出
              d.区分コード.startsWith("1")
          ),
          "区分コード",
          "名称1"
        )
      )
      set単位区分DataMap(
        new wjcGrid.DataMap<T区分マスタ>(
          区分マスタRes.data.filter(
            (d) => d.分類コード === 区分分類コード.マスタ.単位区分
          ),
          "区分コード",
          "名称1"
        )
      )
      set課税区分DataMap(
        new wjcGrid.DataMap<T区分マスタ>(
          区分マスタRes.data.filter(
            (d) => d.分類コード === 区分分類コード.受注配車_請求支払.課税区分
          ),
          "区分コード",
          "名称1"
        )
      )
      set税込区分DataMap(
        new wjcGrid.DataMap<T区分マスタ>(
          区分マスタRes.data.filter(
            (d) => d.分類コード === 区分分類コード.受注配車_請求支払.税込区分
          ),
          "区分コード",
          "名称1"
        )
      )
      setAGC高速料対象荷主コードList(
        区分マスタRes.data
          .filter(
            (d) =>
              d.分類コード ===
              区分分類コード.受注配車_請求支払.AGC高速料対象荷主コード区分
          )
          .map((d) => d.名称1)
      )

      setComboDataInitialized(true)
    })
  }, [])

  //useEffect内ではasyncが使用できないため外部に記述
  const 荷主取得 = async (荷主コード?: string) => {
    if (荷主コード == null || wjCore.isNullOrWhiteSpace(荷主コード ?? "")) {
      set荷主ID(undefined)
      set荷主名("")
      set荷主請求ItemSource([])
      set請求内訳ItemSource([])
      return
    }
    try {
      const 荷主res = await new NinusiService().getList({
        荷主コード,
        完全一致フラグ: true,
      })

      if (荷主res != null && 荷主res.data.length > 0) {
        // AGC高速料対象か確認
        if (AGC高速料対象荷主コードList.includes(荷主コード)) {
          setIsAGC高速料対象荷主コード(true)
        } else {
          setIsAGC高速料対象荷主コード(false)
        }
        setモーダル検索用荷主コード(荷主コード)
        const 荷主 = 荷主res.data[0]
        set荷主ID(荷主.荷主ID)
        setモーダル検索用荷主名(荷主.荷主略称1)
        set荷主名(荷主.荷主略称1)
        const ninusiService = new NinusiSeikyuService()
        const 荷主請求res = await ninusiService.getList({
          荷主Id: 荷主.荷主ID,
          削除済み包含フラグ: true,
        })
        if (荷主請求res != null && 荷主請求res.data.length > 0) {
          set荷主請求ItemSource([
            ..._.orderBy(荷主請求res.data, ["荷主コード", "表紙分割コード"]),
          ])
          const 請求内訳Res = await ninusiService.getListUchiwake({
            荷主請求IdList: [...荷主請求res.data.map((d) => d.荷主請求ID)],
          })
          if (請求内訳Res != null && 請求内訳Res.data.length > 0) {
            set請求内訳ItemSource([
              ..._.orderBy(請求内訳Res.data, ["請求内訳コード"]),
            ])
          } else {
            set請求内訳ItemSource([])
          }
        } else {
          set荷主請求ItemSource([])
          set請求内訳ItemSource([])
        }
      } else {
        set荷主ID(undefined)
        set荷主名("")
        set荷主請求ItemSource([])
        set請求内訳ItemSource([])
      }
    } catch (error) {
      dispatch(setAlerts(error))
      set荷主ID(undefined)
      set荷主名("")
      set荷主請求ItemSource([])
      set請求内訳ItemSource([])
    }
  }

  //  荷主請求idの切り替えに合わせて請求内訳の表示データを変更
  useEffect(() => {
    if (請求内訳ComboBox != null) {
      請求内訳ComboBox.collectionView.filter = (item) => {
        return item.荷主請求ID === 荷主請求ID || item.荷主請求内訳ID === 0
      }
      請求内訳ComboBox.isDisabled = ![
        ...請求内訳ComboBox.collectionView.items,
      ].find((item) => {
        return item.荷主請求ID === 荷主請求ID
      })
      請求内訳ComboBox.collectionView.refresh()
      請求内訳ComboBox.refresh()
    }
    // 大陽日酸用フラグ変更
    const 荷主請求 = 荷主請求ItemSource?.find(
      (i) => i.荷主請求ID === 荷主請求ID
    )
    set大陽日酸_運送料フラグ(
      荷主コード === constants.大陽日酸株式会社 &&
        荷主請求?.表紙分割コード ===
          constants.大陽日酸株式会社_運送料_表紙分割コード
    )
  }, [荷主ID, 荷主請求ID])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    if (
      comboDataInitialized &&
      積卸GridInitialized &&
      品名GridInitialized &&
      請求支払GridInitialized &&
      表紙分割ComboBox &&
      請求内訳ComboBox &&
      積受注配車傭車会社ComboBox &&
      卸受注配車傭車会社ComboBox &&
      請求区分ComboBox &&
      稼働掛率ComboBox &&
      積受注配車運行部所ComboBox &&
      卸受注配車運行部所ComboBox &&
      受注部所ComboBox
    ) {
      setPageInitialized(true)
    }
  }, [
    comboDataInitialized,
    積卸GridInitialized,
    品名GridInitialized,
    請求支払GridInitialized,
    表紙分割ComboBox,
    請求内訳ComboBox,
    積受注配車傭車会社ComboBox,
    卸受注配車傭車会社ComboBox,
    請求区分ComboBox,
    稼働掛率ComboBox,
    積受注配車運行部所ComboBox,
    卸受注配車運行部所ComboBox,
    受注部所ComboBox,
  ])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (pageInitialized) {
      //初回filter作成時にidがいた場合、検索を行う
      if (id != null) {
        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(id)
          .then((res) => {
            if (res && res.data) {
              //共通項目は積受注配車より登録
              const 積受注配車 = res.data.積受注配車
              setData(res.data)
              set積卸情報({
                data: create積卸CollectionView(積受注配車.積卸情報),
              })
              // 品名情報を一覧化する
              let tmp品名情報: T品名情報[] = 積受注配車.積卸情報.flatMap(
                (d) => [...d.品名情報]
              )
              // 特殊条件に対応しているか判定
              if (SYプロモーション特殊条件合致チェック(積受注配車)) {
                setIsSY特殊条件(true)
              } else {
                setIsSY特殊条件(false)
              }

              set品名情報({ data: create品名CollectionView(tmp品名情報) })
              set請求支払情報({
                data: create請求支払CollectionView(積受注配車),
              })
              荷主請求Ref.current = 積受注配車.荷主請求ID
              isPrompt.current = true
            }
          })
          .finally(() => {
            //取得した積卸情報に対して工程順のdatMapを作成する
            let column = 品名flexGrid?.getColumn("工程順")
            if (column) {
              const data: T積卸情報Grid[] =
                積卸flexGrid?.collectionView.sourceCollection
              column.dataMap = new wjcGrid.DataMap(
                _.uniq(
                  data.filter((d) => d.工程順 != null).map((d) => d.工程順)
                )
              )
              column.dataMapEditor = wjcGrid.DataMapEditor.DropDownList
            }
            dispatch(画面ロック解除())
            積卸flexGrid?.refresh()
            品名flexGrid?.refresh()
            請求flexGrid?.refresh()
            setGetDataFinished(true)
          })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
        set積卸情報({ data: create積卸CollectionView() })
        if (品名情報 == null) {
          set品名情報({ data: create品名CollectionView() })
        }
        積卸flexGrid?.refresh()
        品名flexGrid?.refresh()
        isPrompt.current = true
        // 初期値をログインユーザの部所コードとする
        set積受注配車運行部所コード(userInfo.部所コード)
        set受注部所コード(userInfo.部所コード)
        setGetDataFinished(true)
      }
    }
  }, [pageInitialized])

  //ファンクション内部のstate更新のためイベント付け替え
  useEffect(() => {
    積卸flexGrid?.formatItem.removeAllHandlers()
    積卸flexGrid?.formatItem.addHandler(積卸formatItemHandler)
    積卸flexGrid?.rowEditEnded.removeAllHandlers()
    積卸flexGrid?.rowEditEnded.addHandler(積卸RowEditEndedHandler)
    積卸flexGrid?.beginningEdit.removeAllHandlers()
    積卸flexGrid?.beginningEdit.addHandler(積卸beginningEditHandler)

    品名flexGrid?.cellEditEnded.removeAllHandlers()
    品名flexGrid?.cellEditEnded.addHandler(品名CellEditEndedHandler)
    品名flexGrid?.pastedCell.removeAllHandlers()
    品名flexGrid?.pastedCell.addHandler(品名PastedCellHandler)
    品名flexGrid?.formatItem.removeAllHandlers()
    品名flexGrid?.formatItem.addHandler(品名formatItemHandler)
    品名flexGrid?.beginningEdit.removeAllHandlers()
    品名flexGrid?.beginningEdit.addHandler(品名beginningEditHandler)

    請求flexGrid?.formatItem.removeAllHandlers()
    請求flexGrid?.formatItem.addHandler(請求formatItemHandler)
    請求flexGrid?.beginningEdit.removeAllHandlers()
    請求flexGrid?.beginningEdit.addHandler(請求beginningEditHandler)
    if (品名flexGrid?.collectionView == null) return
    const 品名InnerCollectionView =
      品名flexGrid.collectionView as wjCore.CollectionView<T品名情報Grid>
    品名InnerCollectionView.newItemCreator = 品名情報newItemCreator
  }, [
    積卸flexGrid,
    品名flexGrid,
    請求flexGrid,
    請求額確認区分コード,
    請求処理状態区分コード,
    荷主ID,
    荷主請求ID,
    積受注配車同乗者ID,
    品代端数計算区分コード,
    荷主請求ItemSource,
    請求区分コード,
    休日List,
    受注パターンコード,
  ])

  useEffect(() => {
    請求flexGrid?.cellEditEnded.removeAllHandlers()
    請求flexGrid?.cellEditEnded.addHandler(請求CellEditEndedHandler)
    請求flexGrid?.pastedCell.removeAllHandlers()
    請求flexGrid?.pastedCell.addHandler(請求PastedCellHandler)
  }, [積受注配車同乗者ID, 積受注配車同乗者売上, isSY特殊条件])

  // 請求区分コードが変更になったとき、品数毎でなければ運送料・単価・付帯料をリセット
  useEffect(() => {
    品名flexGrid?.beginningEdit.removeAllHandlers()
    品名flexGrid?.beginningEdit.addHandler(品名beginningEditHandler)
    品名flexGrid?.formatItem.removeAllHandlers()
    品名flexGrid?.formatItem.addHandler(品名formatItemHandler)
    品名flexGrid?.cellEditEnded.removeAllHandlers()
    品名flexGrid?.cellEditEnded.addHandler(品名CellEditEndedHandler)
    品名flexGrid?.pastedCell.removeAllHandlers()
    品名flexGrid?.pastedCell.addHandler(品名PastedCellHandler)

    if (請求区分コード !== e請求支払区分.品数毎 && 品名GridInitialized) {
      品名情報.data.items.forEach((d) => {
        d.付帯料 = undefined
        d.運送料 = undefined
        if (請求区分コード !== e請求支払区分.請求支払なし) {
          d.単価 = undefined
        }
      })
      // 初期のデータ差し込み時は動かないように修正
      if (getDataFinished) {
        const 合計運送料 = 品名情報.data.items
          .map((d) => (!d.運送料 ? 0 : d.運送料))
          .reduce((resultData, 運送料) => resultData + 運送料, 0)
        if (請求flexGrid) {
          const 請求GridData: T請求支払情報Grid[] =
            請求flexGrid.collectionView.sourceCollection
          const 請求Data = 請求GridData.find((d) => d.種別 === "請求")

          if (請求Data) {
            請求Data.運送料金額 = 合計運送料
            //SYの特殊条件のときだけ初期付帯料を入れる
            if (isSY特殊条件) {
              請求Data.付帯料金額 = SYプロモーション特殊条件.付帯料
            }
            請求額再計算(請求Data)
          }
        }
        請求flexGrid?.refresh()
      }
      品名flexGrid?.refresh()
    }
  }, [請求区分コード])

  //請求内訳の変更に合わせて計上基準日、請求車番も変更する
  // また、積卸情報の日付の変更を確認した場合にも更新をおこなう
  useEffect(() => {
    if (請求内訳id) {
      const 請求内訳 = 請求内訳ItemSource?.find(
        (i) => i.荷主請求内訳ID === 請求内訳id
      )
      if (請求内訳) {
        set計上基準日区分名称(請求内訳.計上基準日区分名称1)
        set計上基準日区分コード(請求内訳.計上基準日区分コード)
        // 請求計上日入力
        if (積卸GridInitialized) {
          if (請求内訳.計上基準日区分コード === e計上基準日区分.積日) {
            let 積情報: T積卸情報Grid[] = 積卸情報.data.items.filter(
              (d) => d.工程区分コード === e工程区分.積
            )
            if (積情報.length > 0) {
              let 積基準日 = 積卸情報.data.items[0].積卸日
              set請求計上日(積基準日)
            }
          } else if (請求内訳.計上基準日区分コード === e計上基準日区分.卸日) {
            let 卸情報: T積卸情報Grid[] = 積卸情報.data.items.filter(
              (d) => d.工程区分コード === e工程区分.卸
            )
            if (卸情報.length > 0) {
              let 卸基準日: string | undefined =
                卸情報[卸情報.length - 1].積卸日
              set請求計上日(卸基準日)
            }
          }
          // 請求車番入力
          if (請求内訳.請求車輌区分コード === e請求車輌区分.ヘッド) {
            set請求車番(積受注配車車番)
          } else if (請求内訳.請求車輌区分コード === e請求車輌区分.トレーラー) {
            set請求車番(積受注配車トレーラ車番)
          } else {
            set請求車番(undefined)
          }
        }
      } else {
        set計上基準日区分名称("")
        set請求計上日("")
        set請求車番("")
      }
    } else {
      set計上基準日区分名称("")
      set請求計上日("")
      set請求車番("")
    }
  }, [請求内訳id, 請求内訳ItemSource])

  useEffect(() => {
    if (計上基準日区分コード == null && !積卸日isChanged) return

    if (積卸GridInitialized) {
      if (計上基準日区分コード === e計上基準日区分.積日) {
        let 積情報: T積卸情報Grid[] = 積卸情報.data.items.filter(
          (d) => d.工程区分コード === e工程区分.積
        )
        if (積情報.length > 0) {
          let 積基準日 = 積卸情報.data.items[0].積卸日
          set請求計上日(積基準日)
        }
      } else if (計上基準日区分コード === e計上基準日区分.卸日) {
        let 卸情報: T積卸情報Grid[] = 積卸情報.data.items.filter(
          (d) => d.工程区分コード === e工程区分.卸
        )
        if (卸情報.length > 0) {
          let 卸基準日: string | undefined = 卸情報[卸情報.length - 1].積卸日
          set請求計上日(卸基準日)
        }
      }
    }
    set積卸日isChanged(false)
  }, [積卸日isChanged])

  useEffect(() => {
    部所ItemSource &&
      setSelect受注部所(
        部所ItemSource.find((d) => d.部所コード === 受注部所コード)
      )
  }, [受注部所コード])

  useEffect(() => {
    積受注配車運行部所コードRef.current = 積受注配車運行部所コード
  }, [積受注配車運行部所コード])

  useEffect(() => {
    卸受注配車運行部所コードRef.current = 卸受注配車運行部所コード
  }, [卸受注配車運行部所コード])

  // オートコンプリートのフォーカスが外れた後の処理
  useEffect(() => {
    // 請求車番の初期値を入力する
    if (請求内訳id) {
      const 請求内訳 = 請求内訳ItemSource?.find(
        (i) => i.荷主請求内訳ID === 請求内訳id
      )
      if (請求内訳) {
        if (請求内訳.請求車輌区分コード === e請求車輌区分.ヘッド) {
          set請求車番(積受注配車車番)
        } else if (請求内訳.請求車輌区分コード === e請求車輌区分.トレーラー) {
          set請求車番(積受注配車トレーラ車番)
        } else {
          set請求車番(undefined)
        }
      }
    }
    setIsSyaryoLostFocus(false)
  }, [isSyaryoLostFocus])

  // 高速料税込区分を荷主請求より取得し、変更
  useEffect(() => {
    if (請求flexGrid) {
      請求flexGrid.collectionView.beginUpdate()
      const sourceCollection: T請求支払情報Grid[] =
        請求flexGrid.collectionView.sourceCollection
      sourceCollection.forEach((請求支払情報) => {
        請求支払情報.高速料金税込区分コード = 高速料税込区分コード
      })
      請求flexGrid.collectionView.endUpdate()
      請求flexGrid.collectionView.refresh()
    }
  }, [高速料税込区分コード])

  //SYプロモーション用処理
  useEffect(() => {
    if (!積卸flexGrid) return
    const 積卸情報 = 積卸flexGrid.collectionView
      .sourceCollection as T積卸パターン情報[]
    if (
      SYプロモーション特殊条件合致チェック({
        荷主コード,
        車番: 積受注配車車番,
        乗務員コード: 積受注配車乗務員コード,
        積卸情報,
      })
    ) {
      if (請求flexGrid) {
        const 請求支払CollectionView =
          請求flexGrid.collectionView as wjCore.CollectionView<T請求支払情報Grid>
        const 請求支払ItemsSource =
          請求支払CollectionView.sourceCollection as T請求支払情報Grid[]
        const 請求Data = 請求支払ItemsSource[0]
        if (請求Data.付帯料金額 == null) {
          請求Data.付帯料金額 = constants.SYプロモーション特殊条件.付帯料
          請求Data.備考 = constants.SYプロモーション特殊条件.請求備考
          請求支払CollectionView.refresh()
          請求flexGrid.refresh()
        }
        // 請求付帯料は乗務員付帯料に反映しないため0に戻す
        set積受注配車乗務員付帯料(0)
      }
      setIsSY特殊条件(true)
    } else {
      setIsSY特殊条件(false)
    }
    if (積卸先コード変更フラグ) {
      set積卸先コード変更フラグ(false)
    }
  }, [
    荷主コード,
    積受注配車車番,
    積受注配車乗務員コード,
    積卸flexGrid,
    積卸先コード変更フラグ,
  ])
  //#endregion

  return (
    <>
      <Prompt
        when={isPrompt.current}
        message={CONSTANT.MESSAGES.BROWSER_BACK}></Prompt>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">分割受注配車入力</span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row>
          <Col>
            <Card className="w-110rem">
              <Card.Header>
                <span>{id && `受注番号:`}</span>
                <span className="user-select-all">
                  {id
                    ? `${searchResult?.積受注配車.受注伝票番号 ?? ""}`
                    : "新規登録"}
                </span>
              </Card.Header>
              <Card.Body>
                <Form>
                  <Container className="register-form" fluid>
                    <Row>
                      <Col>
                        <Table className="form-table">
                          <tbody>
                            <tr>
                              <th className="min-w-8rem">パターンコード</th>
                              <td>
                                <div className="input-group d-flex">
                                  {id != null ? (
                                    <TextInput
                                      id="受注パターンコード"
                                      isReadOnly={true}
                                      name="受注パターンコード"
                                      value={受注パターンコード}
                                      setValue={set受注パターンコード}
                                      maxLength={20}
                                    />
                                  ) : (
                                    <>
                                      <div className="w-13rem">
                                        <wjrInput.AutoComplete
                                          headerPath={"受注配車パターンコード"}
                                          showDropDownButton={false}
                                          delay={200}
                                          selectedValue={受注パターンコード}
                                          isEditable={true}
                                          gotFocus={(
                                            control: wjcInput.AutoComplete
                                          ) => {
                                            control.itemsSourceFunction =
                                              getPatternItemsSource(
                                                受注部所コードRef.current ?? ""
                                              )
                                          }}
                                          lostFocus={(
                                            control: wjcInput.AutoComplete
                                          ) => {
                                            if (control.selectedItem) {
                                              const 受注パターン: TZyutyuHaisyaPatternListGetRes =
                                                control.selectedItem
                                              set受注パターンコード(
                                                受注パターン.受注配車パターンコード
                                              )
                                            } else {
                                              // 1つしかアイテムがない場合、先頭を取得し埋め込む
                                              const itemsSource: wjCore.CollectionView =
                                                control.itemsSource
                                              const sourceCollection: TZyutyuHaisyaPatternListGetRes[] =
                                                itemsSource?.sourceCollection ??
                                                []
                                              if (
                                                sourceCollection.length === 1
                                              ) {
                                                const 受注パターン: TZyutyuHaisyaPatternListGetRes =
                                                  sourceCollection[0]
                                                control.selectedItem =
                                                  受注パターン
                                                set受注パターンコード(
                                                  受注パターン.受注配車パターンコード
                                                )
                                              } else {
                                                set受注パターンコード(
                                                  control.text ?? ""
                                                )
                                              }
                                            }
                                          }}
                                          displayMemberPath="displayName"
                                          selectedValuePath="受注配車パターンコード"></wjrInput.AutoComplete>
                                      </div>

                                      <button
                                        type="button"
                                        className="icon-button"
                                        disabled={is請求確認済()}
                                        onClick={(e) => {
                                          e.preventDefault()
                                          setモーダル検索用荷主コード(
                                            荷主コード
                                          )
                                          setモーダル検索用荷主名(荷主名)
                                          setIs受注配車パターン検索Modal(true)
                                        }}>
                                        <FontAwesomeIcon
                                          className="icon-button-inner"
                                          icon={faSearch}></FontAwesomeIcon>
                                      </button>

                                      <Button
                                        className="btn btn-small"
                                        style={{
                                          margin: "auto",
                                          marginLeft: ".3rem",
                                          borderTopLeftRadius: "0.25rem",
                                          borderBottomLeftRadius: "0.25rem",
                                        }}
                                        disabled={
                                          is請求確認済() ||
                                          受注パターンコード === "" ||
                                          受注パターンコード == null ||
                                          受注部所コード == null ||
                                          受注部所コード === ""
                                        }
                                        onClick={(e) => {
                                          e.preventDefault()
                                          e.stopPropagation()
                                          if (
                                            受注パターンコード !== "" &&
                                            受注パターンコード != null &&
                                            受注部所コード !== "" &&
                                            受注部所コード != null
                                          ) {
                                            setパターンデータ({
                                              受注配車パターンコード:
                                                受注パターンコード,
                                              受注部所コード,
                                            })
                                          }
                                        }}>
                                        反映
                                      </Button>
                                    </>
                                  )}
                                </div>
                              </td>
                              <th className="min-w-8rem">
                                受注部所
                                <RequiredMark />
                              </th>
                              <td>
                                <ComboBox.Busyo
                                  isLoadEnded={受注部所isLoadEnded}
                                  setIsLoadEnded={set受注部所isLoadEnded}
                                  defaultValue={userInfo.部所コード}
                                  isEmpty={true}
                                  isRequired={true}
                                  isDisabled={is請求確認済()}
                                  listFilter={(d) => d.運行部所フラグ === 1}
                                  itemsSource={部所ItemSource}
                                  selectedValue={受注部所コード}
                                  className={
                                    isInvalid受注部所 ? "is-error" : ""
                                  }
                                  setSelectedValue={(v) => {
                                    set受注部所コード(v)
                                    受注部所コードRef.current = v ?? undefined
                                    // 受注部所変更時は運行部所は自動反映
                                    // 初回だけは連動しないように修正
                                    if (!isRestoreSearching) {
                                      set積受注配車運行部所コード(
                                        v ?? undefined
                                      )
                                    }
                                  }}
                                  ComboBox={受注部所ComboBox}
                                  setComboBox={
                                    set受注部所ComboBox
                                  }></ComboBox.Busyo>
                              </td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr>
                              <th className="min-w-8rem">
                                荷主
                                <RequiredMark />
                              </th>
                              <td colSpan={3}>
                                <div className="input-group">
                                  <TextInput
                                    style={{ width: "6rem" }}
                                    id="荷主コード"
                                    isReadOnly={is請求確認済()}
                                    name="荷主コード"
                                    value={荷主コード}
                                    className={
                                      isInvalid荷主コード ? "is-error" : ""
                                    }
                                    setValue={async (v) => {
                                      荷主コードRef.current = v
                                      set荷主コード(v)
                                    }}
                                    onBlur={() => {
                                      荷主取得(荷主コードRef.current)
                                    }}
                                    maxLength={5}
                                    placeholder="荷主CD"
                                  />
                                  {!is請求確認済() && (
                                    <button
                                      type="button"
                                      className="icon-button"
                                      disabled={is請求確認済()}>
                                      <a
                                        href="*"
                                        onClick={(e) => {
                                          e.preventDefault()
                                          setIs荷主検索Modal(true)
                                        }}>
                                        <FontAwesomeIcon icon={faSearch} />
                                      </a>
                                    </button>
                                  )}
                                  <TextInput
                                    style={{ width: "30rem" }}
                                    id="荷主名"
                                    isReadOnly={true}
                                    name="荷主名"
                                    value={荷主名}
                                    setValue={set荷主名}
                                    maxLength={100}
                                    placeholder="荷主名"
                                  />
                                </div>
                              </td>
                              <th className="min-w-8rem">請求額確認</th>
                              <td>
                                <TextInput
                                  id="請求額確認区分名称1"
                                  name="請求額確認区分名称1"
                                  value={請求額確認区分名称1}
                                  isReadOnly={true}
                                  setValue={set請求額確認区分名称1}
                                  maxLength={50}
                                />
                              </td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr>
                              <th className="min-w-8rem">
                                表紙名
                                <RequiredMark />
                              </th>
                              <td>
                                <div>
                                  <ComboBox.HyosiBunkatu
                                    itemsSource={荷主請求ItemSource}
                                    isLoadEnded={表紙分割IsLoadEnded}
                                    setIsLoadEnded={set表紙分割IsLoadEnded}
                                    isEmpty={true}
                                    lostFocus={(control) => {
                                      const selectedItem =
                                        control.selectedItem as TNinusiSeikyuListGetRes
                                      if (
                                        selectedItem &&
                                        selectedItem.荷主請求ID != null &&
                                        selectedItem.荷主請求ID !== 0
                                      ) {
                                        set高速料税込区分コード(
                                          selectedItem.高速料税込区分コード
                                        )
                                        set品代端数計算区分コード(
                                          selectedItem.品代端数計算区分コード
                                        )
                                      } else {
                                        set高速料税込区分コード("")
                                        set品代端数計算区分コード("")
                                      }
                                    }}
                                    isDisabled={is請求確認済()}
                                    setSelectedValue={(v) => {
                                      set荷主請求ID(v)
                                      荷主請求Ref.current = v
                                    }}
                                    selectedValue={荷主請求ID}
                                    ComboBox={表紙分割ComboBox}
                                    className={
                                      isInvalid表紙名 ? "is-error" : ""
                                    }
                                    setComboBox={
                                      set表紙分割ComboBox
                                    }></ComboBox.HyosiBunkatu>
                                </div>
                              </td>
                              <th className="min-w-8rem">荷主依頼No</th>
                              <td>
                                <TextInput
                                  id="荷主依頼No"
                                  name="荷主依頼No"
                                  isReadOnly={is請求確認済()}
                                  value={荷主依頼番号}
                                  setValue={set荷主依頼番号}
                                  maxLength={50}
                                />
                              </td>
                              <th className="min-w-8rem">
                                請求区分
                                <RequiredMark />
                              </th>
                              <td>
                                <ComboBox.Kubun
                                  分類コード={
                                    区分分類コード.受注配車_請求支払.請求区分
                                  }
                                  isRequired={true}
                                  className={
                                    isInvalid請求区分 ? "is-error" : ""
                                  }
                                  itemsSource={区分ItemSource}
                                  isLoadEnded={請求区分isLoadEnded}
                                  // MEMO:車建てと品数毎だけにする
                                  listFilter={(d) =>
                                    [
                                      e請求支払区分.品数毎,
                                      e請求支払区分.車建て,
                                    ].includes(d.区分コード as "1" | "2")
                                  }
                                  isEmpty={true}
                                  isDisabled={is請求確認済()}
                                  setIsLoadEnded={set請求区分isLoadEnded}
                                  selectedValue={請求区分コード}
                                  setSelectedValue={(v) => {
                                    set請求区分コード(v)
                                  }}
                                  ComboBox={請求区分ComboBox}
                                  setComboBox={
                                    set請求区分ComboBox
                                  }></ComboBox.Kubun>
                              </td>
                              <th className="min-w-8rem">繰返数</th>
                              <td>
                                <NumberInput
                                  style={{ width: "4rem" }}
                                  disabled={is請求確認済()}
                                  id="繰返数"
                                  name="繰返数"
                                  value={繰返数}
                                  setValue={set繰返数}
                                  step={1}
                                  min={1}
                                />
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </Col>
                    </Row>
                    {/* grid部 */}
                    <Row>
                      <Col>
                        <h5>積卸情報</h5>
                        {/* 積卸情報のgrid */}
                        <wjrGrid.FlexGrid
                          {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT}
                          allowSorting={false}
                          allowDragging={wjcGrid.AllowDragging.Rows}
                          allowMerging={wjcGrid.AllowMerging.ColumnHeaders}
                          itemsSource={積卸情報.data}
                          initialized={積卸initializedHandler}
                          allowAddNew={!is請求確認済()}>
                          <wjrGrid.FlexGridColumn
                            binding="工程順"
                            width={60}
                            dataType={wjCore.DataType.Number}
                            isReadOnly={true}
                            cssClassAll={"read-only-cell"}
                            header="工程順">
                            <RequiredHeader></RequiredHeader>
                          </wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="工程区分コード"
                            width={120}
                            dataMap={工程区分DataMap}
                            header="工程区分">
                            <RequiredHeader></RequiredHeader>
                          </wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="積卸日"
                            width={120}
                            isRequired={false}
                            editor={
                              new wjcInput.InputDate(
                                document.createElement("div"),
                                {
                                  isRequired: false,
                                  format: "yyyyMMdd",
                                }
                              )
                            }
                            format={"d"}
                            header="日付">
                            <RequiredHeader></RequiredHeader>
                            <wjrGrid.FlexGridCellTemplate
                              cellType="Cell"
                              template={(
                                context: TWijmoCellTemplateContext<T積卸情報Grid>
                              ) => {
                                let dDate = ""
                                if (context.item.積卸日)
                                  dDate = dayjs(context.item.積卸日).format(
                                    "YYYY/MM/DD"
                                  )
                                return (
                                  <>
                                    <span>{dDate}</span>
                                  </>
                                )
                              }}></wjrGrid.FlexGridCellTemplate>
                          </wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="積卸時間"
                            width={80}
                            isRequired={false}
                            header="時間"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="積卸先コード"
                            width={100}
                            isRequired={false}
                            header="積卸先CD"
                            editor={
                              new wjcInput.AutoComplete(
                                document.createElement("div"),
                                {
                                  minLength: 1,
                                  isEditable: true,
                                  delay: 300,
                                  itemsSourceFunction: (
                                    query: string,
                                    max: number,
                                    callback: wjcInput.IGetItemsCallback
                                  ) => {
                                    if (
                                      荷主コード == null ||
                                      荷主コード === ""
                                    ) {
                                      callback([])
                                      return
                                    }
                                    return get積卸ItemsSourceByApi(
                                      query,
                                      max,
                                      callback,
                                      荷主コード
                                    )
                                  },
                                  displayMemberPath: "displayName",
                                  selectedValuePath: "積卸先コード",
                                }
                              )
                            }>
                            <wjrGrid.FlexGridCellTemplate
                              cellType="Cell"
                              template={(
                                context: TWijmoCellTemplateContext<T積卸情報Grid>
                              ) => {
                                if (is請求確認済()) {
                                  return <></>
                                }
                                return (
                                  <div className="d-flex justify-content-between">
                                    <div className="text-start">
                                      {context.item.積卸先コード}
                                    </div>
                                    <div className="text-end">
                                      {/* 荷主の整合性のためにぬしIDがいない場合表示しない */}
                                      {荷主ID != null && (
                                        <a
                                          href="*"
                                          onClick={(e) => {
                                            e.preventDefault()
                                            set選択行(context.row)
                                            setIs積卸先検索Modal(true)
                                          }}>
                                          <FontAwesomeIcon icon={faSearch} />
                                        </a>
                                      )}
                                    </div>
                                  </div>
                                )
                              }}></wjrGrid.FlexGridCellTemplate>
                          </wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="積卸先名"
                            width={250}
                            isRequired={false}
                            header="積卸先名"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="積卸先都道府県"
                            isRequired={false}
                            header="都道府県"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="積卸先市区町村"
                            isRequired={false}
                            header="市区町村"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="積卸先番地"
                            isRequired={false}
                            header="町名番地"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="受注配車工程ID"
                            width={64}
                            isReadOnly={true}
                            header="削除">
                            <wjrGrid.FlexGridCellTemplate
                              cellType="Cell"
                              template={(
                                context: TWijmoCellTemplateContext<T積卸情報Grid>
                              ) => {
                                const boundItem: T積卸情報Grid = context.item
                                if (
                                  積卸flexGrid &&
                                  isFirstRow(積卸flexGrid, boundItem.row_id)
                                )
                                  return <></>
                                return boundItem.削除フラグ !== 1 ? (
                                  <Button
                                    className="btn btn-small btn-primary move-edit-page"
                                    variant={"caution"}
                                    disabled={is請求確認済()}
                                    onClick={(e) => {
                                      e.preventDefault()
                                      e.stopPropagation()
                                      if (
                                        積卸情報 == null ||
                                        積卸情報.data == null
                                      )
                                        return
                                      if (boundItem) {
                                        // サーバーから附番されたIDを持つかで処理分岐
                                        if (boundItem.受注配車工程ID) {
                                          // 削除フラグON
                                          積卸情報.data.beginUpdate()
                                          boundItem.削除フラグ = 1
                                          積卸情報.data.endUpdate()
                                          積卸情報.data.commitEdit()
                                        } else {
                                          // 行削除
                                          積卸情報.data.remove(boundItem)
                                        }
                                      }
                                    }}>
                                    削除
                                  </Button>
                                ) : (
                                  <Button
                                    className="btn btn-small btn-primary move-edit-page"
                                    variant={"pending"}
                                    onClick={(e) => {
                                      e.preventDefault()
                                      e.stopPropagation()
                                      if (
                                        積卸情報 == null ||
                                        積卸情報.data == null
                                      )
                                        return
                                      if (boundItem) {
                                        // サーバーから附番されたIDを持つかで処理分岐
                                        if (boundItem.受注配車工程ID) {
                                          // 削除フラグON
                                          積卸情報.data.beginUpdate()
                                          boundItem.削除フラグ = 0
                                          積卸情報.data.endUpdate()
                                          積卸情報.data.commitEdit()
                                        }
                                      }
                                    }}>
                                    解除
                                  </Button>
                                )
                              }}
                            />
                          </wjrGrid.FlexGridColumn>
                        </wjrGrid.FlexGrid>
                        {荷主ID == null && (
                          <span className="text-danger fw-bold">
                            荷主未選択の場合、コード入力による積卸先の自動反映はされません。
                          </span>
                        )}
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <h5>品名情報</h5>
                        {/* 品名情報のgrid */}
                        <wjrGrid.FlexGrid
                          {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT}
                          allowSorting={false}
                          allowDragging={wjcGrid.AllowDragging.Rows}
                          allowAddNew={!is請求確認済()}
                          itemsSource={品名情報.data}
                          initialized={品名initializedHandler}>
                          <wjrGrid.FlexGridColumn
                            binding="工程順"
                            width={60}
                            header="工程順">
                            <RequiredHeader></RequiredHeader>
                          </wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="品コード"
                            width={100}
                            isRequired={false}
                            header="品CD"
                            editor={
                              new wjcInput.AutoComplete(
                                document.createElement("div"),
                                {
                                  minLength: 1,
                                  isEditable: true,
                                  delay: 20,
                                  itemsSourceFunction: (
                                    query: string,
                                    max: number,
                                    callback: wjcInput.IGetItemsCallback
                                  ) => {
                                    if (
                                      荷主コード == null ||
                                      荷主コード === ""
                                    ) {
                                      callback([])
                                      return
                                    }
                                    return get品名ItemsSourceByApi(
                                      query,
                                      max,
                                      callback,
                                      荷主コード
                                    )
                                  },
                                  displayMemberPath: "displayName",
                                  selectedValuePath: "品コード",
                                }
                              )
                            }>
                            <wjrGrid.FlexGridCellTemplate
                              cellType="Cell"
                              template={(
                                context: TWijmoCellTemplateContext<T品名情報Grid>
                              ) => {
                                if (is請求確認済()) {
                                  return <></>
                                }
                                return (
                                  <div className="d-flex justify-content-between">
                                    <div className="text-start">
                                      {context.item.品コード}
                                    </div>
                                    <div className="text-end">
                                      {/* 荷主の整合性のためにぬしIDがいない場合表示しない */}
                                      {荷主ID != null && (
                                        <a
                                          href="*"
                                          onClick={(e) => {
                                            e.preventDefault()
                                            set選択行(context.row)
                                            setIs品名検索Modal(true)
                                          }}>
                                          <FontAwesomeIcon icon={faSearch} />
                                        </a>
                                      )}
                                    </div>
                                  </div>
                                )
                              }}></wjrGrid.FlexGridCellTemplate>
                          </wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="品名"
                            width={250}
                            isRequired={false}
                            header="品名"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="数量"
                            isRequired={false}
                            width={110}
                            dataType={wjCore.DataType.Number}
                            format={"N3"}
                            editor={
                              new wjcInput.InputNumber(
                                document.createElement("div"),
                                {
                                  format: "N3",
                                  isRequired: false,
                                }
                              )
                            }
                            header="数量"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="単位区分コード"
                            width={80}
                            dataMap={単位区分DataMap}
                            header="単位"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="単価"
                            isRequired={false}
                            dataType={wjCore.DataType.Number}
                            header="単価"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="運送料"
                            isRequired={false}
                            dataType={wjCore.DataType.Number}
                            header="運送料"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="付帯料"
                            isRequired={false}
                            dataType={wjCore.DataType.Number}
                            header="付帯料"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="積載品ID"
                            width={64}
                            isReadOnly={true}
                            header="削除">
                            <wjrGrid.FlexGridCellTemplate
                              cellType="Cell"
                              template={(
                                context: TWijmoCellTemplateContext<T品名情報Grid>
                              ) => {
                                const boundItem: T品名情報Grid = context.item
                                return boundItem.削除フラグ !== 1 ? (
                                  <Button
                                    className="btn btn-small btn-primary move-edit-page"
                                    variant={"caution"}
                                    disabled={is請求確認済()}
                                    onClick={(e) => {
                                      e.preventDefault()
                                      e.stopPropagation()
                                      if (
                                        品名情報 == null ||
                                        品名情報.data == null
                                      )
                                        return
                                      if (boundItem) {
                                        // サーバーから附番されたIDを持つかで処理分岐
                                        if (boundItem.積載品ID) {
                                          // 削除フラグON
                                          品名情報.data.beginUpdate()
                                          boundItem.削除フラグ = 1
                                          品名情報.data.endUpdate()
                                          品名情報.data.commitEdit()
                                        } else {
                                          // 行削除
                                          品名情報.data.remove(boundItem)
                                        }
                                      }
                                    }}>
                                    削除
                                  </Button>
                                ) : (
                                  <Button
                                    className="btn btn-small btn-primary move-edit-page"
                                    variant={"pending"}
                                    onClick={(e) => {
                                      e.preventDefault()
                                      e.stopPropagation()
                                      if (
                                        品名情報 == null ||
                                        品名情報.data == null
                                      )
                                        return
                                      if (boundItem) {
                                        // サーバーから附番されたIDを持つかで処理分岐
                                        if (boundItem.積載品ID) {
                                          // 削除フラグON
                                          品名情報.data.beginUpdate()
                                          boundItem.削除フラグ = 0
                                          品名情報.data.endUpdate()
                                          品名情報.data.commitEdit()
                                        }
                                      }
                                    }}>
                                    解除
                                  </Button>
                                )
                              }}
                            />
                          </wjrGrid.FlexGridColumn>
                        </wjrGrid.FlexGrid>
                        {荷主ID == null && (
                          <span className="text-danger fw-bold">
                            荷主未選択の場合、コード入力による品名情報の自動反映はされません。
                          </span>
                        )}
                      </Col>
                    </Row>
                  </Container>
                  <Container className="register-form mt-3" fluid>
                    <Row>
                      <Col>
                        <h5>車輌・乗務員情報</h5>
                        <Table className={"w-100"}>
                          <tbody>
                            <tr>
                              <td>
                                {/* 積受注配車 */}
                                <Table className="form-table vertical">
                                  <tbody>
                                    <tr>
                                      <th
                                        colSpan={2}
                                        className="text-start fs-4">
                                        <span className={"fw-bold "}>積</span>
                                        運行
                                      </th>
                                      <th className="text-start fs-4">
                                        <span className={"fw-bold "}>卸</span>
                                        運行
                                      </th>
                                      <th className="text-start text-danger fw-bold fs-4">
                                        請求なし
                                      </th>
                                    </tr>
                                    <tr>
                                      <th className="min-w-8rem">配車状態</th>
                                      <td>
                                        <ComboBox.Kubun
                                          分類コード={
                                            区分分類コード.受注配車_請求支払
                                              .配車状態区分
                                          }
                                          isRequired={false}
                                          itemsSource={区分ItemSource}
                                          isLoadEnded={
                                            積受注配車配車状態isLoadEnded
                                          }
                                          isEmpty={true}
                                          isDisabled={is請求確認済()}
                                          setIsLoadEnded={
                                            set積受注配車配車状態isLoadEnded
                                          }
                                          listFilter={(d) =>
                                            d.区分コード.length < 2
                                          } // 受注配車の配車状態区分の区分コードは一桁
                                          selectedValue={
                                            積受注配車配車状態区分コード
                                          }
                                          setSelectedValue={(v) => {
                                            set積受注配車配車状態区分コード(v)
                                          }}
                                          ComboBox={積受注配車配車状態ComboBox}
                                          setComboBox={
                                            set積受注配車配車状態ComboBox
                                          }></ComboBox.Kubun>
                                      </td>
                                      <th className="min-w-8rem">配車状態</th>
                                      <td>
                                        <ComboBox.Kubun
                                          分類コード={
                                            区分分類コード.受注配車_請求支払
                                              .配車状態区分
                                          }
                                          isRequired={false}
                                          itemsSource={区分ItemSource}
                                          isLoadEnded={
                                            卸受注配車配車状態isLoadEnded
                                          }
                                          isEmpty={true}
                                          isDisabled={is請求確認済()}
                                          setIsLoadEnded={
                                            set卸受注配車配車状態isLoadEnded
                                          }
                                          listFilter={(d) =>
                                            d.区分コード.length < 2
                                          } // 受注配車の配車状態区分の区分コードは一桁
                                          selectedValue={
                                            卸受注配車配車状態区分コード
                                          }
                                          setSelectedValue={(v) => {
                                            set卸受注配車配車状態区分コード(v)
                                          }}
                                          ComboBox={卸受注配車配車状態ComboBox}
                                          setComboBox={
                                            set卸受注配車配車状態ComboBox
                                          }></ComboBox.Kubun>
                                      </td>
                                    </tr>
                                    <tr>
                                      <th className="min-w-8rem">運行部所</th>
                                      <td>
                                        <ComboBox.Busyo
                                          isLoadEnded={
                                            積受注配車運行部所isLoadEnded
                                          }
                                          setIsLoadEnded={
                                            set積受注配車運行部所isLoadEnded
                                          }
                                          isRequired={false}
                                          isEmpty={true}
                                          itemsSource={部所ItemSource}
                                          isDisabled={is請求確認済()}
                                          selectedValue={
                                            積受注配車運行部所コード
                                          }
                                          listFilter={(d) =>
                                            d.運行部所フラグ === 1
                                          }
                                          setSelectedValue={(v) => {
                                            set積受注配車運行部所コード(
                                              v ?? undefined
                                            )
                                          }}
                                          ComboBox={積受注配車運行部所ComboBox}
                                          setComboBox={
                                            set積受注配車運行部所ComboBox
                                          }></ComboBox.Busyo>
                                      </td>
                                      <th className="min-w-8rem">運行部所</th>
                                      <td>
                                        <ComboBox.Busyo
                                          isLoadEnded={
                                            卸受注配車運行部所isLoadEnded
                                          }
                                          setIsLoadEnded={
                                            set卸受注配車運行部所isLoadEnded
                                          }
                                          isRequired={false}
                                          isEmpty={true}
                                          itemsSource={部所ItemSource}
                                          isDisabled={is請求確認済()}
                                          selectedValue={
                                            卸受注配車運行部所コード
                                          }
                                          listFilter={(d) =>
                                            d.運行部所フラグ === 1
                                          }
                                          setSelectedValue={(v) => {
                                            set卸受注配車運行部所コード(
                                              v ?? undefined
                                            )
                                          }}
                                          ComboBox={卸受注配車運行部所ComboBox}
                                          setComboBox={
                                            set卸受注配車運行部所ComboBox
                                          }></ComboBox.Busyo>
                                      </td>
                                    </tr>
                                    <tr>
                                      <th className="min-w-8rem">車番</th>
                                      <td>
                                        <div className="input-group">
                                          <wjrInput.AutoComplete
                                            className={
                                              isInvalid積受注配車車番
                                                ? "w-5rem is-error"
                                                : "w-5rem"
                                            }
                                            headerPath={"車番"}
                                            text={積受注配車車番}
                                            minLength={1}
                                            isReadOnly={is請求確認済()}
                                            showDropDownButton={false}
                                            gotFocus={
                                              積受注配車車輛GotFocusHandler
                                            }
                                            lostFocus={積車輌LostFocus}
                                            displayMemberPath={"displayName"}
                                            selectedValuePath={"車番"}
                                            maxLength={4}
                                            placeholder="車番"
                                          />
                                          {!is請求確認済() && (
                                            <button
                                              type="button"
                                              className="icon-button"
                                              disabled={is請求確認済()}
                                              onClick={車輌検索ModalClickHandler(
                                                積受注配車運行部所コード,
                                                積受注配車傭車会社コード,
                                                "積",
                                                1
                                              )}>
                                              <FontAwesomeIcon
                                                className="icon-button-inner"
                                                icon={
                                                  faSearch
                                                }></FontAwesomeIcon>
                                            </button>
                                          )}
                                          <TextInput
                                            id="積車輌ID"
                                            name="積車輌ID"
                                            style={{
                                              width: "4.75rem",
                                            }}
                                            value={積受注配車車輌ID?.toString()}
                                            setValue={() => {}}
                                            isReadOnly
                                            placeholder="ID"
                                          />
                                          <TextInput
                                            id="車名"
                                            name="車名"
                                            value={積受注配車車種区分名称}
                                            setValue={set積受注配車車種区分名称}
                                            isReadOnly
                                            placeholder="車種"
                                          />
                                          <div className="w-6rem">
                                            <NumberInput
                                              id="積載量"
                                              name="最大積載量"
                                              value={積受注配車最大積載量}
                                              setValue={set積受注配車最大積載量}
                                              readOnly
                                              placeholder="積載量"
                                            />
                                          </div>
                                        </div>
                                      </td>
                                      <th className="min-w-8rem">車番</th>
                                      <td>
                                        <div className="input-group">
                                          <wjrInput.AutoComplete
                                            className={
                                              isInvalid卸受注配車車番
                                                ? "w-5rem is-error"
                                                : "w-5rem"
                                            }
                                            headerPath={"車番"}
                                            text={卸受注配車車番}
                                            minLength={1}
                                            isReadOnly={is請求確認済()}
                                            showDropDownButton={false}
                                            gotFocus={
                                              卸受注配車車輛GotFocusHandler
                                            }
                                            lostFocus={卸車輌LostFocus}
                                            displayMemberPath={"displayName"}
                                            selectedValuePath={"車番"}
                                            maxLength={4}
                                            placeholder="車番"
                                          />
                                          {!is請求確認済() && (
                                            <button
                                              type="button"
                                              className="icon-button"
                                              disabled={is請求確認済()}
                                              onClick={車輌検索ModalClickHandler(
                                                卸受注配車運行部所コード,
                                                卸受注配車傭車会社コード,
                                                "卸",
                                                1
                                              )}>
                                              <FontAwesomeIcon
                                                className="icon-button-inner"
                                                icon={
                                                  faSearch
                                                }></FontAwesomeIcon>
                                            </button>
                                          )}
                                          <TextInput
                                            id="卸車輌ID"
                                            name="卸ID"
                                            style={{
                                              width: "4.75rem",
                                            }}
                                            value={卸受注配車車輌ID?.toString()}
                                            setValue={() => {}}
                                            isReadOnly
                                            placeholder="ID"
                                          />
                                          <TextInput
                                            id="車名"
                                            name="車名"
                                            value={卸受注配車車種区分名称}
                                            setValue={set卸受注配車車種区分名称}
                                            isReadOnly
                                            placeholder="車種"
                                          />
                                          <div className="w-6rem">
                                            <NumberInput
                                              id="積載量"
                                              name="最大積載量"
                                              value={卸受注配車最大積載量}
                                              setValue={set卸受注配車最大積載量}
                                              readOnly
                                              placeholder="積載量"
                                            />
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <th className="min-w-8rem">
                                        トレーラ車番
                                      </th>
                                      <td>
                                        <div className="input-group">
                                          <wjrInput.AutoComplete
                                            className={
                                              isInvalid積受注配車トレーラ車番
                                                ? "w-5rem is-error"
                                                : "w-5rem"
                                            }
                                            headerPath={"車番"}
                                            text={積受注配車トレーラ車番}
                                            isReadOnly={is請求確認済()}
                                            minLength={1}
                                            showDropDownButton={false}
                                            gotFocus={トレーラ車輛GotFocus(
                                              積受注配車運行部所コードRef
                                            )}
                                            lostFocus={積トレーラ車輛LostFocus}
                                            displayMemberPath={"displayName"}
                                            selectedValuePath={"車番"}
                                            maxLength={4}
                                            placeholder="トレーラ車番"
                                          />
                                          {!is請求確認済() && (
                                            <button
                                              type="button"
                                              className="icon-button"
                                              disabled={is請求確認済()}
                                              onClick={車輌検索ModalClickHandler(
                                                積受注配車運行部所コード,
                                                積受注配車傭車会社コード,
                                                "積",
                                                0
                                              )}>
                                              <FontAwesomeIcon
                                                className="icon-button-inner"
                                                icon={
                                                  faSearch
                                                }></FontAwesomeIcon>
                                            </button>
                                          )}
                                          <TextInput
                                            id="積トレーラ車輌ID"
                                            name="積トレーラ車輌ID"
                                            style={{
                                              width: "4.75rem",
                                            }}
                                            value={積受注配車トレーラ車輌ID?.toString()}
                                            setValue={() => {}}
                                            isReadOnly
                                            placeholder="ID"
                                          />
                                          <TextInput
                                            id="トレーラ車名"
                                            name="トレーラ車名"
                                            value={
                                              積受注配車トレーラ車種区分名称
                                            }
                                            setValue={
                                              set積受注配車トレーラ車種区分名称
                                            }
                                            isReadOnly
                                            maxLength={100}
                                            placeholder="トレーラ車種"
                                          />
                                          <div className="w-6rem">
                                            <NumberInput
                                              id="積載量"
                                              name="最大積載量"
                                              value={
                                                積受注配車トレーラ最大積載量
                                              }
                                              setValue={
                                                set積受注配車トレーラ最大積載量
                                              }
                                              readOnly
                                              placeholder="積載量"
                                            />
                                          </div>
                                        </div>
                                      </td>
                                      <th className="min-w-8rem">
                                        トレーラ車番
                                      </th>
                                      <td>
                                        <div className="input-group">
                                          <wjrInput.AutoComplete
                                            className={
                                              isInvalid卸受注配車トレーラ車番
                                                ? "w-5rem is-error"
                                                : "w-5rem"
                                            }
                                            headerPath={"車番"}
                                            text={卸受注配車トレーラ車番}
                                            isReadOnly={is請求確認済()}
                                            minLength={1}
                                            showDropDownButton={false}
                                            gotFocus={トレーラ車輛GotFocus(
                                              卸受注配車運行部所コードRef
                                            )}
                                            lostFocus={卸トレーラ車輛LostFocus}
                                            displayMemberPath={"displayName"}
                                            selectedValuePath={"車番"}
                                            maxLength={4}
                                            placeholder="トレーラ車番"
                                          />
                                          {!is請求確認済() && (
                                            <button
                                              type="button"
                                              className="icon-button"
                                              disabled={is請求確認済()}
                                              onClick={車輌検索ModalClickHandler(
                                                卸受注配車運行部所コード,
                                                卸受注配車傭車会社コード,
                                                "卸",
                                                0
                                              )}>
                                              <FontAwesomeIcon
                                                className="icon-button-inner"
                                                icon={
                                                  faSearch
                                                }></FontAwesomeIcon>
                                            </button>
                                          )}
                                          <TextInput
                                            id="卸トレーラ車輌ID"
                                            name="卸トレーラ車輌ID"
                                            style={{
                                              width: "4.75rem",
                                            }}
                                            value={卸受注配車トレーラ車輌ID?.toString()}
                                            setValue={() => {}}
                                            isReadOnly
                                            placeholder="ID"
                                          />
                                          <TextInput
                                            id="トレーラ車名"
                                            name="トレーラ車名"
                                            value={
                                              卸受注配車トレーラ車種区分名称
                                            }
                                            setValue={
                                              set卸受注配車トレーラ車種区分名称
                                            }
                                            isReadOnly
                                            maxLength={100}
                                            placeholder="トレーラ車種"
                                          />
                                          <div className="w-6rem">
                                            <NumberInput
                                              id="積載量"
                                              name="最大積載量"
                                              value={
                                                卸受注配車トレーラ最大積載量
                                              }
                                              setValue={
                                                set卸受注配車トレーラ最大積載量
                                              }
                                              readOnly
                                              placeholder="積載量"
                                            />
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <th className="min-w-8rem">乗務員</th>
                                      <td>
                                        <div className="input-group">
                                          <TextInput
                                            style={{ width: "5rem" }}
                                            isReadOnly={
                                              is請求確認済() ||
                                              !wjCore.isNullOrWhiteSpace(
                                                積受注配車傭車会社コード ?? ""
                                              )
                                            }
                                            id="乗務員"
                                            name="乗務員コード"
                                            onBlur={積受注配車乗務員BlurHandler}
                                            value={積受注配車乗務員コード}
                                            setValue={(v) => {
                                              set積受注配車乗務員コード(v)
                                              if (v === "" || !v) {
                                                set積受注配車乗務員ID(undefined)
                                              }
                                            }}
                                            maxLength={4}
                                            placeholder="社員CD"
                                          />
                                          {!is請求確認済() &&
                                            wjCore.isNullOrWhiteSpace(
                                              積受注配車傭車会社コード ?? ""
                                            ) && (
                                              <button
                                                type="button"
                                                className="icon-button"
                                                disabled={is請求確認済()}>
                                                <a
                                                  href="*"
                                                  onClick={(e) => {
                                                    e.preventDefault()
                                                    setIs受注配車検索(true)
                                                    set乗務員検索対象("乗務員")
                                                    setIs乗務員検索Modal(true)
                                                  }}>
                                                  <FontAwesomeIcon
                                                    className="icon-button-inner"
                                                    icon={
                                                      faSearch
                                                    }></FontAwesomeIcon>
                                                </a>
                                              </button>
                                            )}
                                          <TextInput
                                            id="乗務員名"
                                            name="乗務員名"
                                            isReadOnly={
                                              is請求確認済() ||
                                              wjCore.isNullOrWhiteSpace(
                                                積受注配車傭車会社コード ?? ""
                                              )
                                            }
                                            value={積受注配車乗務員名}
                                            setValue={set積受注配車乗務員名}
                                            maxLength={100}
                                            placeholder="乗務員名"
                                          />
                                        </div>
                                      </td>
                                      <th className="min-w-8rem">乗務員</th>
                                      <td>
                                        <div className="input-group">
                                          <TextInput
                                            style={{ width: "5rem" }}
                                            isReadOnly={
                                              is請求確認済() ||
                                              !wjCore.isNullOrWhiteSpace(
                                                卸受注配車傭車会社コード ?? ""
                                              )
                                            }
                                            id="乗務員"
                                            name="乗務員コード"
                                            onBlur={卸受注配車乗務員BlurHandler}
                                            value={卸受注配車乗務員コード}
                                            setValue={(v) => {
                                              set卸受注配車乗務員コード(v)
                                              if (v === "" || !v) {
                                                set卸受注配車乗務員ID(undefined)
                                              }
                                            }}
                                            maxLength={4}
                                            placeholder="社員CD"
                                          />
                                          {!is請求確認済() &&
                                            wjCore.isNullOrWhiteSpace(
                                              卸受注配車傭車会社コード ?? ""
                                            ) && (
                                              <button
                                                type="button"
                                                className="icon-button"
                                                disabled={is請求確認済()}>
                                                <a
                                                  href="*"
                                                  onClick={(e) => {
                                                    e.preventDefault()
                                                    setIs受注配車検索(false)
                                                    set乗務員検索対象("乗務員")
                                                    setIs乗務員検索Modal(true)
                                                  }}>
                                                  <FontAwesomeIcon
                                                    className="icon-button-inner"
                                                    icon={
                                                      faSearch
                                                    }></FontAwesomeIcon>
                                                </a>
                                              </button>
                                            )}
                                          <TextInput
                                            id="乗務員名"
                                            name="乗務員名"
                                            isReadOnly={
                                              is請求確認済() ||
                                              wjCore.isNullOrWhiteSpace(
                                                卸受注配車傭車会社コード ?? ""
                                              )
                                            }
                                            value={卸受注配車乗務員名}
                                            setValue={set卸受注配車乗務員名}
                                            maxLength={100}
                                            placeholder="乗務員名"
                                          />
                                        </div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <th className="min-w-8rem">同乗者</th>
                                      <td>
                                        <div className="input-group">
                                          <TextInput
                                            style={{ width: "5rem" }}
                                            id="同乗者"
                                            name="同乗者コード"
                                            onBlur={積受注配車同乗者BlurHandler}
                                            isReadOnly={
                                              is請求確認済() ||
                                              !wjCore.isNullOrWhiteSpace(
                                                積受注配車傭車会社コード ?? ""
                                              )
                                            }
                                            value={積受注配車同乗者コード}
                                            setValue={(v) => {
                                              set積受注配車同乗者コード(v)
                                              if (v === "" || !v) {
                                                set積受注配車同乗者ID(undefined)
                                              }
                                            }}
                                            maxLength={4}
                                            placeholder="社員CD"
                                          />
                                          {!is請求確認済() &&
                                            wjCore.isNullOrWhiteSpace(
                                              積受注配車傭車会社コード ?? ""
                                            ) && (
                                              <button
                                                type="button"
                                                className="icon-button"
                                                disabled={is請求確認済()}>
                                                <a
                                                  href="*"
                                                  onClick={(e) => {
                                                    e.preventDefault()
                                                    setIs受注配車検索(true)
                                                    set乗務員検索対象("同乗者")
                                                    setIs乗務員検索Modal(true)
                                                  }}>
                                                  <FontAwesomeIcon
                                                    className="icon-button-inner"
                                                    icon={
                                                      faSearch
                                                    }></FontAwesomeIcon>
                                                </a>
                                              </button>
                                            )}
                                          <TextInput
                                            id="同乗者名"
                                            name="同乗者名"
                                            isReadOnly={
                                              is請求確認済() ||
                                              wjCore.isNullOrWhiteSpace(
                                                積受注配車傭車会社コード ?? ""
                                              )
                                            }
                                            value={積受注配車同乗者名}
                                            setValue={set積受注配車同乗者名}
                                            maxLength={100}
                                            placeholder="同乗者名"
                                          />
                                        </div>
                                      </td>
                                      <th className="min-w-8rem">同乗者</th>
                                      <td>
                                        <div className="input-group">
                                          <TextInput
                                            style={{ width: "5rem" }}
                                            id="同乗者"
                                            name="同乗者コード"
                                            onBlur={卸受注配車同乗者BlurHandler}
                                            isReadOnly={
                                              is請求確認済() ||
                                              !wjCore.isNullOrWhiteSpace(
                                                卸受注配車傭車会社コード ?? ""
                                              )
                                            }
                                            value={卸受注配車同乗者コード}
                                            setValue={(v) => {
                                              set卸受注配車同乗者コード(v)
                                              if (v === "" || !v) {
                                                set卸受注配車同乗者ID(undefined)
                                              }
                                            }}
                                            maxLength={4}
                                            placeholder="社員CD"
                                          />
                                          {!is請求確認済() &&
                                            wjCore.isNullOrWhiteSpace(
                                              卸受注配車傭車会社コード ?? ""
                                            ) && (
                                              <button
                                                type="button"
                                                className="icon-button"
                                                disabled={is請求確認済()}>
                                                <a
                                                  href="*"
                                                  onClick={(e) => {
                                                    e.preventDefault()
                                                    setIs受注配車検索(false)
                                                    set乗務員検索対象("同乗者")
                                                    setIs乗務員検索Modal(true)
                                                  }}>
                                                  <FontAwesomeIcon
                                                    className="icon-button-inner"
                                                    icon={
                                                      faSearch
                                                    }></FontAwesomeIcon>
                                                </a>
                                              </button>
                                            )}
                                          <TextInput
                                            id="同乗者名"
                                            name="同乗者名"
                                            isReadOnly={
                                              is請求確認済() ||
                                              wjCore.isNullOrWhiteSpace(
                                                卸受注配車傭車会社コード ?? ""
                                              )
                                            }
                                            value={卸受注配車同乗者名}
                                            setValue={set卸受注配車同乗者名}
                                            maxLength={100}
                                            placeholder="同乗者名"
                                          />
                                        </div>
                                      </td>
                                    </tr>

                                    <tr>
                                      <th className="min-w-8rem">傭車会社</th>
                                      <td>
                                        <ComboBox.SiharaiSaki
                                          siharaiSaki={e支払先区分.傭車先}
                                          isLoadEnded={
                                            積受注配車傭車会社isLoadEnded
                                          }
                                          setIsLoadEnded={
                                            set積受注配車傭車会社isLoadEnded
                                          }
                                          isRequired={false}
                                          isEmpty={true}
                                          isDisabled={is請求確認済()}
                                          lostFocus={(control) => {
                                            // 傭車選択時点で車輌の情報は消す
                                            if (control.selectedItem) {
                                              // ヘッド車輌
                                              set積受注配車車輌ID(undefined)
                                              set積受注配車車番("")
                                              set積受注配車車種区分名称("")
                                              set積受注配車最大積載量(0)
                                              set積受注配車稼働掛率区分コード(
                                                ""
                                              )
                                              // トレーラ車輌
                                              set積受注配車トレーラ車輌ID(
                                                undefined
                                              )
                                              set積受注配車トレーラ車番("")
                                              set積受注配車トレーラ車種区分名称(
                                                ""
                                              )
                                              set積受注配車トレーラ最大積載量(0)
                                              // 乗務員
                                              set積受注配車乗務員ID(undefined)
                                              set積受注配車乗務員コード("")
                                              set積受注配車乗務員名("")
                                              // 同乗者
                                              set積受注配車同乗者ID(undefined)
                                              set積受注配車同乗者コード("")
                                              set積受注配車同乗者名("")
                                              set積受注配車同乗者場所コード("")
                                              // 手当系
                                              set積受注配車食事手当(undefined)
                                              set積受注配車乗務員売上(undefined)
                                              set積受注配車同乗者売上(undefined)
                                              set積受注配車乗務員付帯料(
                                                undefined
                                              )
                                              set積受注配車付帯高速料(undefined)
                                              set請求車番(undefined)
                                            }
                                          }}
                                          itemsSource={支払先ItemSource}
                                          selectedValue={
                                            積受注配車傭車会社コード
                                          }
                                          setSelectedValue={(v) => {
                                            積受注配車傭車会社コードRef.current =
                                              v ?? ""
                                            set積受注配車傭車会社コード(v)
                                          }}
                                          ComboBox={積受注配車傭車会社ComboBox}
                                          setComboBox={
                                            set積受注配車傭車会社ComboBox
                                          }></ComboBox.SiharaiSaki>
                                      </td>
                                      <th className="min-w-8rem">傭車会社</th>
                                      <td>
                                        <ComboBox.SiharaiSaki
                                          siharaiSaki={e支払先区分.傭車先}
                                          isLoadEnded={
                                            卸受注配車傭車会社isLoadEnded
                                          }
                                          setIsLoadEnded={
                                            set卸受注配車傭車会社isLoadEnded
                                          }
                                          isRequired={false}
                                          isEmpty={true}
                                          isDisabled={is請求確認済()}
                                          lostFocus={(control) => {
                                            // 傭車選択時点で車輌の情報は消す
                                            if (control.selectedItem) {
                                              // ヘッド車輌
                                              set卸受注配車車輌ID(undefined)
                                              set卸受注配車車番("")
                                              set卸受注配車車種区分名称("")
                                              set卸受注配車最大積載量(0)
                                              set卸受注配車稼働掛率区分コード(
                                                ""
                                              )
                                              // トレーラ車輌
                                              set卸受注配車トレーラ車輌ID(
                                                undefined
                                              )
                                              set卸受注配車トレーラ車番("")
                                              set卸受注配車トレーラ車種区分名称(
                                                ""
                                              )
                                              set卸受注配車トレーラ最大積載量(0)
                                              // 乗務員
                                              set卸受注配車乗務員ID(undefined)
                                              set卸受注配車乗務員コード("")
                                              set卸受注配車乗務員名("")
                                              // 同乗者
                                              set卸受注配車同乗者ID(undefined)
                                              set卸受注配車同乗者コード("")
                                              set卸受注配車同乗者名("")
                                              set卸受注配車同乗者場所コード("")
                                              // 手当系
                                              set卸受注配車食事手当(undefined)
                                              set卸受注配車乗務員売上(undefined)
                                              set卸受注配車同乗者売上(undefined)
                                              set卸受注配車乗務員付帯料(
                                                undefined
                                              )
                                              set卸受注配車付帯高速料(undefined)
                                            }
                                          }}
                                          itemsSource={支払先ItemSource}
                                          selectedValue={
                                            卸受注配車傭車会社コード
                                          }
                                          setSelectedValue={(v) => {
                                            卸受注配車傭車会社コードRef.current =
                                              v ?? ""
                                            set卸受注配車傭車会社コード(v)
                                          }}
                                          ComboBox={卸受注配車傭車会社ComboBox}
                                          setComboBox={
                                            set卸受注配車傭車会社ComboBox
                                          }></ComboBox.SiharaiSaki>
                                      </td>
                                    </tr>
                                    <tr>
                                      <th className="min-w-8rem">乗務員売上</th>
                                      <td>
                                        <div className="input-group">
                                          <wjrInput.InputNumber
                                            id="乗務員売上"
                                            name="乗務員売上"
                                            value={積受注配車乗務員売上}
                                            isReadOnly={
                                              is請求確認済() ||
                                              !wjCore.isNullOrWhiteSpace(
                                                積受注配車傭車会社コード ?? ""
                                              )
                                            }
                                            handleWheel={false}
                                            format={"n0"}
                                            isRequired={false}
                                            valueChanged={(
                                              c: wjcInput.InputNumber,
                                              e: any
                                            ) => {
                                              c.value != null
                                                ? set積受注配車乗務員売上(
                                                    c.value
                                                  )
                                                : set積受注配車乗務員売上(
                                                    undefined
                                                  )
                                            }}
                                          />
                                        </div>
                                      </td>
                                      <th className="min-w-8rem">乗務員売上</th>
                                      <td>
                                        <div className="input-group">
                                          <wjrInput.InputNumber
                                            id="乗務員売上"
                                            name="乗務員売上"
                                            value={卸受注配車乗務員売上}
                                            isReadOnly={
                                              is請求確認済() ||
                                              !wjCore.isNullOrWhiteSpace(
                                                卸受注配車傭車会社コード ?? ""
                                              )
                                            }
                                            handleWheel={false}
                                            format={"n0"}
                                            isRequired={false}
                                            valueChanged={(
                                              c: wjcInput.InputNumber,
                                              e: any
                                            ) => {
                                              c.value != null
                                                ? set卸受注配車乗務員売上(
                                                    c.value
                                                  )
                                                : set卸受注配車乗務員売上(
                                                    undefined
                                                  )
                                            }}
                                          />
                                        </div>
                                      </td>
                                    </tr>

                                    <tr>
                                      <th className="min-w-8rem">
                                        乗務員付帯料
                                      </th>
                                      <td>
                                        <div className="input-group">
                                          <wjrInput.InputNumber
                                            id="乗務員付帯料"
                                            name="乗務員付帯料"
                                            value={積受注配車乗務員付帯料}
                                            handleWheel={false}
                                            isReadOnly={
                                              is請求確認済() ||
                                              !wjCore.isNullOrWhiteSpace(
                                                積受注配車傭車会社コード ?? ""
                                              )
                                            }
                                            format={"n0"}
                                            isRequired={false}
                                            valueChanged={(
                                              c: wjcInput.InputNumber,
                                              e: any
                                            ) => {
                                              c.value != null
                                                ? set積受注配車乗務員付帯料(
                                                    c.value
                                                  )
                                                : set積受注配車乗務員付帯料(
                                                    undefined
                                                  )
                                            }}
                                          />
                                        </div>
                                      </td>
                                      <th className="min-w-8rem">
                                        乗務員付帯料
                                      </th>
                                      <td>
                                        <div className="input-group">
                                          <wjrInput.InputNumber
                                            id="乗務員付帯料"
                                            name="乗務員付帯料"
                                            value={卸受注配車乗務員付帯料}
                                            handleWheel={false}
                                            isReadOnly={
                                              is請求確認済() ||
                                              !wjCore.isNullOrWhiteSpace(
                                                卸受注配車傭車会社コード ?? ""
                                              )
                                            }
                                            format={"n0"}
                                            isRequired={false}
                                            valueChanged={(
                                              c: wjcInput.InputNumber,
                                              e: any
                                            ) => {
                                              c.value != null
                                                ? set卸受注配車乗務員付帯料(
                                                    c.value
                                                  )
                                                : set卸受注配車乗務員付帯料(
                                                    undefined
                                                  )
                                            }}
                                          />
                                        </div>
                                      </td>
                                    </tr>

                                    <tr>
                                      <th className="min-w-8rem">付帯高速料</th>
                                      <td>
                                        <div className="input-group">
                                          <wjrInput.InputNumber
                                            id="付帯高速料"
                                            name="付帯高速料"
                                            value={積受注配車付帯高速料}
                                            handleWheel={false}
                                            isReadOnly={
                                              is請求確認済() ||
                                              !wjCore.isNullOrWhiteSpace(
                                                積受注配車傭車会社コード ?? ""
                                              )
                                            }
                                            format={"n0"}
                                            isRequired={false}
                                            valueChanged={(
                                              c: wjcInput.InputNumber,
                                              e: any
                                            ) => {
                                              c.value != null
                                                ? set積受注配車付帯高速料(
                                                    c.value
                                                  )
                                                : set積受注配車付帯高速料(
                                                    undefined
                                                  )
                                            }}
                                          />
                                        </div>
                                      </td>
                                      <th className="min-w-8rem">付帯高速料</th>
                                      <td>
                                        <div className="input-group">
                                          <wjrInput.InputNumber
                                            id="付帯高速料"
                                            name="付帯高速料"
                                            value={卸受注配車付帯高速料}
                                            handleWheel={false}
                                            isReadOnly={
                                              is請求確認済() ||
                                              !wjCore.isNullOrWhiteSpace(
                                                卸受注配車傭車会社コード ?? ""
                                              )
                                            }
                                            format={"n0"}
                                            isRequired={false}
                                            valueChanged={(
                                              c: wjcInput.InputNumber,
                                              e: any
                                            ) => {
                                              c.value != null
                                                ? set卸受注配車付帯高速料(
                                                    c.value
                                                  )
                                                : set卸受注配車付帯高速料(
                                                    undefined
                                                  )
                                            }}
                                          />
                                        </div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <th className="min-w-8rem">ETC</th>
                                      <td>
                                        <wjrInput.InputNumber
                                          id="ETC"
                                          name="ETC"
                                          value={積ETC}
                                          handleWheel={false}
                                          isReadOnly={true}
                                          format={"n0"}
                                          isRequired={false}
                                          valueChanged={(
                                            c: wjcInput.InputNumber,
                                            e: any
                                          ) => {
                                            c.value != null
                                              ? set積ETC(c.value)
                                              : set積ETC(undefined)
                                          }}
                                        />
                                      </td>
                                      <th className="min-w-8rem">ETC</th>
                                      <td>
                                        <wjrInput.InputNumber
                                          id="ETC"
                                          name="ETC"
                                          value={卸ETC}
                                          handleWheel={false}
                                          isReadOnly={true}
                                          format={"n0"}
                                          isRequired={false}
                                          valueChanged={(
                                            c: wjcInput.InputNumber,
                                            e: any
                                          ) => {
                                            c.value != null
                                              ? set卸ETC(c.value)
                                              : set卸ETC(undefined)
                                          }}
                                        />
                                      </td>
                                    </tr>
                                    <tr>
                                      <th className="min-w-8rem">食事手当</th>
                                      <td>
                                        <ComboBox.Kubun
                                          分類コード={
                                            区分分類コード.マスタ.食事手当区分
                                          }
                                          isRequired={false}
                                          isEmpty={true}
                                          className={"w-13rem"}
                                          itemsSource={区分ItemSource}
                                          isLoadEnded={
                                            積受注配車食事手当区分isLoadEnded
                                          }
                                          isDisabled={
                                            is請求確認済() ||
                                            !wjCore.isNullOrWhiteSpace(
                                              積受注配車傭車会社コード ?? ""
                                            )
                                          }
                                          setIsLoadEnded={
                                            set積受注配車食事手当区分isLoadEnded
                                          }
                                          displayTextFormatter={(i) =>
                                            i.数値1 != null
                                              ? i.数値1.toString()
                                              : ""
                                          }
                                          selectedValue={
                                            積受注配車食事手当区分コード
                                          }
                                          setSelectedItem={(v) => {
                                            set積受注配車食事手当(v?.数値1)
                                          }}
                                          setSelectedValue={(v) => {
                                            set積受注配車食事手当区分コード(v)
                                          }}
                                          ComboBox={
                                            積受注配車食事手当区分ComboBox
                                          }
                                          setComboBox={
                                            set積受注配車食事手当区分ComboBox
                                          }></ComboBox.Kubun>
                                      </td>
                                      <th className="min-w-8rem">食事手当</th>
                                      <td>
                                        <ComboBox.Kubun
                                          分類コード={
                                            区分分類コード.マスタ.食事手当区分
                                          }
                                          isRequired={false}
                                          isEmpty={true}
                                          className={"w-13rem"}
                                          itemsSource={区分ItemSource}
                                          isLoadEnded={
                                            卸受注配車食事手当区分isLoadEnded
                                          }
                                          isDisabled={
                                            is請求確認済() ||
                                            !wjCore.isNullOrWhiteSpace(
                                              卸受注配車傭車会社コード ?? ""
                                            )
                                          }
                                          setIsLoadEnded={
                                            set卸受注配車食事手当区分isLoadEnded
                                          }
                                          displayTextFormatter={(i) =>
                                            i.数値1 != null
                                              ? i.数値1.toString()
                                              : ""
                                          }
                                          selectedValue={
                                            卸受注配車食事手当区分コード
                                          }
                                          setSelectedItem={(v) => {
                                            set卸受注配車食事手当(v?.数値1)
                                          }}
                                          setSelectedValue={(v) => {
                                            set卸受注配車食事手当区分コード(v)
                                          }}
                                          ComboBox={
                                            卸受注配車食事手当区分ComboBox
                                          }
                                          setComboBox={
                                            set卸受注配車食事手当区分ComboBox
                                          }></ComboBox.Kubun>
                                      </td>
                                    </tr>
                                    <tr>
                                      <th className="min-w-8rem">稼働掛率</th>
                                      <td>
                                        <ComboBox.Kubun
                                          分類コード={
                                            区分分類コード.受注配車_請求支払
                                              .稼働手当車種掛率区分
                                          }
                                          isRequired={false}
                                          isReadOnly={true}
                                          itemsSource={区分ItemSource}
                                          isLoadEnded={稼働掛率isLoadEnded}
                                          isEmpty={true}
                                          isDisabled={
                                            is請求確認済() ||
                                            !wjCore.isNullOrWhiteSpace(
                                              積受注配車傭車会社コード ?? ""
                                            )
                                          }
                                          setIsLoadEnded={
                                            set稼働掛率isLoadEnded
                                          }
                                          selectedValue={
                                            積受注配車稼働掛率区分コード
                                          }
                                          setSelectedValue={(v) => {
                                            set積受注配車稼働掛率区分コード(v)
                                          }}
                                          ComboBox={稼働掛率ComboBox}
                                          setComboBox={
                                            set稼働掛率ComboBox
                                          }></ComboBox.Kubun>
                                      </td>
                                      <th className="min-w-8rem">稼働掛率</th>
                                      <td>
                                        <ComboBox.Kubun
                                          分類コード={
                                            区分分類コード.受注配車_請求支払
                                              .稼働手当車種掛率区分
                                          }
                                          isRequired={false}
                                          isReadOnly={true}
                                          itemsSource={区分ItemSource}
                                          isLoadEnded={稼働掛率isLoadEnded}
                                          isEmpty={true}
                                          isDisabled={
                                            is請求確認済() ||
                                            !wjCore.isNullOrWhiteSpace(
                                              卸受注配車傭車会社コード ?? ""
                                            )
                                          }
                                          setIsLoadEnded={
                                            set稼働掛率isLoadEnded
                                          }
                                          selectedValue={
                                            卸受注配車稼働掛率区分コード
                                          }
                                          setSelectedValue={(v) => {
                                            set卸受注配車稼働掛率区分コード(v)
                                          }}
                                          ComboBox={稼働掛率ComboBox}
                                          setComboBox={
                                            set稼働掛率ComboBox
                                          }></ComboBox.Kubun>
                                      </td>
                                    </tr>
                                    <tr>
                                      <th className="min-w-8rem">同乗者売上</th>
                                      <td>
                                        <div className="input-group">
                                          <wjrInput.InputNumber
                                            id="同乗者売上"
                                            name="同乗者売上"
                                            value={積受注配車同乗者売上}
                                            handleWheel={false}
                                            isReadOnly={
                                              is請求確認済() ||
                                              !wjCore.isNullOrWhiteSpace(
                                                積受注配車傭車会社コード ?? ""
                                              )
                                            }
                                            format={"n0"}
                                            isRequired={false}
                                            valueChanged={(
                                              c: wjcInput.InputNumber,
                                              e: any
                                            ) => {
                                              c.value != null
                                                ? set積受注配車同乗者売上(
                                                    c.value
                                                  )
                                                : set積受注配車同乗者売上(
                                                    undefined
                                                  )
                                            }}
                                          />
                                        </div>
                                      </td>
                                      <th className="min-w-8rem">同乗者売上</th>
                                      <td>
                                        <div className="input-group">
                                          <wjrInput.InputNumber
                                            id="同乗者売上"
                                            name="同乗者売上"
                                            value={卸受注配車同乗者売上}
                                            handleWheel={false}
                                            isReadOnly={
                                              is請求確認済() ||
                                              !wjCore.isNullOrWhiteSpace(
                                                卸受注配車傭車会社コード ?? ""
                                              )
                                            }
                                            format={"n0"}
                                            isRequired={false}
                                            valueChanged={(
                                              c: wjcInput.InputNumber,
                                              e: any
                                            ) => {
                                              c.value != null
                                                ? set卸受注配車同乗者売上(
                                                    c.value
                                                  )
                                                : set卸受注配車同乗者売上(
                                                    undefined
                                                  )
                                            }}
                                          />
                                        </div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <th className="min-w-8rem">輸送備考</th>
                                      <td>
                                        <div className="input-group">
                                          <TextAreaInput
                                            style={{
                                              width: "25rem",
                                              height: "100%",
                                            }}
                                            id="輸送備考"
                                            name="輸送備考"
                                            isReadOnly={is請求確認済()}
                                            value={積受注配車輸送備考}
                                            setValue={set積受注配車輸送備考}
                                            placeholder="輸送備考"
                                          />
                                        </div>
                                      </td>
                                      <th className="min-w-8rem">輸送備考</th>
                                      <td>
                                        <div className="input-group">
                                          <TextAreaInput
                                            style={{
                                              width: "25rem",
                                              height: "100%",
                                            }}
                                            id="輸送備考"
                                            name="輸送備考"
                                            isReadOnly={is請求確認済()}
                                            value={卸受注配車輸送備考}
                                            setValue={set卸受注配車輸送備考}
                                            placeholder="輸送備考"
                                          />
                                        </div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <th className="min-w-8rem">コース編集</th>
                                      <td>
                                        <TextInput
                                          style={{ width: "35rem" }}
                                          id="コース編集"
                                          name="コース編集"
                                          value={積受注配車コース編集}
                                          isReadOnly={is請求確認済()}
                                          setValue={(v) => {
                                            set積受注配車コース編集(v)
                                          }}
                                          placeholder="コース編集"
                                        />
                                      </td>
                                      <th className="min-w-8rem">コース編集</th>
                                      <td>
                                        <TextInput
                                          style={{ width: "35rem" }}
                                          id="コース編集"
                                          name="コース編集"
                                          value={卸受注配車コース編集}
                                          isReadOnly={is請求確認済()}
                                          setValue={(v) => {
                                            set卸受注配車コース編集(v)
                                          }}
                                          placeholder="コース編集"
                                        />
                                      </td>
                                    </tr>
                                    {/* 既に特別手当がどちらかに適用されている時に表示 */}
                                    {!!id &&
                                    (!!積受注配車特別手当 ||
                                      !!卸受注配車特別手当) ? (
                                      <tr>
                                        <th className="min-w-8rem">特別手当</th>
                                        <td>
                                          <div className="input-group">
                                            <wjrInput.InputNumber
                                              id="特別手当"
                                              name="特別手当"
                                              value={積受注配車特別手当}
                                              handleWheel={false}
                                              isReadOnly={true}
                                              format={"n0"}
                                              isRequired={false}
                                              valueChanged={(
                                                c: wjcInput.InputNumber,
                                                e: any
                                              ) => {
                                                c.value != null
                                                  ? set積受注配車特別手当(
                                                      c.value
                                                    )
                                                  : set積受注配車特別手当(
                                                      undefined
                                                    )
                                              }}
                                            />
                                          </div>
                                        </td>
                                        <th className="min-w-8rem">特別手当</th>
                                        <td>
                                          <div className="input-group">
                                            <wjrInput.InputNumber
                                              id="特別手当"
                                              name="特別手当"
                                              value={卸受注配車特別手当}
                                              handleWheel={false}
                                              isReadOnly={true}
                                              format={"n0"}
                                              isRequired={false}
                                              valueChanged={(
                                                c: wjcInput.InputNumber,
                                                e: any
                                              ) => {
                                                c.value != null
                                                  ? set卸受注配車特別手当(
                                                      c.value
                                                    )
                                                  : set卸受注配車特別手当(
                                                      undefined
                                                    )
                                              }}
                                            />
                                          </div>
                                        </td>
                                      </tr>
                                    ) : (
                                      <></>
                                    )}
                                    {大陽日酸_運送料フラグ && (
                                      <tr>
                                        <th>走行距離</th>
                                        <td>
                                          <wjrInput.InputNumber
                                            id="走行距離"
                                            name="走行距離"
                                            value={大陽小型車距離}
                                            handleWheel={false}
                                            isReadOnly={is請求確認済()}
                                            format={"G2"}
                                            isRequired={false}
                                            valueChanged={(
                                              c: wjcInput.InputNumber,
                                              e: any
                                            ) => {
                                              c.value != null
                                                ? set大陽小型車距離(c.value)
                                                : set大陽小型車距離(undefined)
                                            }}
                                          />
                                          Km
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </Table>
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </Col>
                    </Row>
                  </Container>

                  <Container className="register-form mt-3" fluid>
                    <Row>
                      <Col>
                        <h5>請求支払情報</h5>
                        <Table className="form-table">
                          <tbody>
                            <tr>
                              <th className="min-w-8rem">
                                請求内訳
                                <RequiredMark />
                              </th>
                              <td>
                                <div className="w-20rem">
                                  <ComboBox.SeikyuUtiwake
                                    itemsSource={請求内訳ItemSource}
                                    isLoadEnded={請求内訳IsLoadEnded}
                                    isDisabled={is請求確認済()}
                                    setIsLoadEnded={set請求内訳IsLoadEnded}
                                    setSelectedValue={(v) => {
                                      set請求内訳id(v)
                                    }}
                                    className={
                                      isInvalid請求内訳 ? "is-error" : ""
                                    }
                                    isEmpty={true}
                                    selectedValue={請求内訳id}
                                    ComboBox={請求内訳ComboBox}
                                    setComboBox={
                                      set請求内訳ComboBox
                                    }></ComboBox.SeikyuUtiwake>
                                </div>
                              </td>
                              <th className="min-w-8rem">請求基準日</th>
                              <td className="w-4 rem">
                                <TextInput
                                  id="計上基準日区分"
                                  name="計上基準日区分"
                                  isReadOnly
                                  value={計上基準日区分名称}
                                  setValue={(v) => {
                                    set計上基準日区分名称(v)
                                  }}
                                />
                              </td>
                              <th className="min-w-8rem">請求計上日</th>
                              <td>
                                <div className="w-8rem">
                                  <DateInput
                                    id="請求計上日"
                                    isRequired={false}
                                    isReadOnly={true}
                                    showDropDownButton={false}
                                    value={請求計上日}
                                    setValue={(v) => {
                                      set請求計上日(v)
                                    }}></DateInput>
                                </div>
                              </td>
                              <th className="min-w-8rem">請求車番</th>
                              <td>
                                <div className="input-group">
                                  {/* 常時読取専用とし、車番・トレーラ車番・請求内訳　変更時に自動で入力内容を変更する */}
                                  <TextInput
                                    style={{ width: "5rem" }}
                                    isReadOnly={true}
                                    id="請求車番"
                                    name="請求車番"
                                    value={請求車番}
                                    setValue={(v) => {
                                      set請求車番(v)
                                    }}
                                    // maxLength={4}
                                  />
                                  <Button
                                    className="ms-2 align-middle my-auto"
                                    variant="primary"
                                    onClick={on卸車番変更ボタンClickHandler}>
                                    卸車番
                                  </Button>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="text-end">
                        <div>
                          {isAGC高速料対象荷主コード && (
                            <Button
                              className="mx-2"
                              type="button"
                              disabled={isSearching || is請求確認済()}
                              onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                setIsAGC高速料検索Modal(true)
                              }}>
                              <FontAwesomeIcon icon={faSearch} />
                              AGC高速料検索
                            </Button>
                          )}

                          <Button
                            className="mx-2"
                            type="button"
                            disabled={isSearching || is請求確認済()}
                            onClick={(e) => {
                              e.stopPropagation()
                              e.preventDefault()
                            }}>
                            <FontAwesomeIcon icon={faSearch} />
                            受注請求履歴
                          </Button>
                          <Button
                            className="mx-2"
                            type="button"
                            disabled={isSearching || is請求確認済()}
                            onClick={(e) => {
                              e.stopPropagation()
                              e.preventDefault()
                            }}>
                            <FontAwesomeIcon icon={faSearch} />
                            運賃タリフ参照
                          </Button>
                        </div>
                        <wjrGrid.FlexGrid
                          {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                          itemsSource={請求支払情報.data}
                          initialized={請求initializedHandler}
                          allowSorting={false}
                          allowDragging={wjcGrid.AllowDragging.None}
                          isReadOnly={false}>
                          <wjrGrid.FlexGridColumn
                            binding="種別"
                            cssClassAll={"read-only-cell"}
                            isReadOnly={true}
                            header="請求支払"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="運送料課税区分コード"
                            width={80}
                            dataMap={課税区分DataMap}
                            header="非/課"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="運送料金額"
                            isRequired={false}
                            dataType={wjCore.DataType.Number}
                            header="運送料"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="付帯料課税区分コード"
                            width={80}
                            dataMap={課税区分DataMap}
                            header="非/課"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="付帯料金額"
                            isRequired={false}
                            dataType={wjCore.DataType.Number}
                            header="付帯料"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="高速料金税込区分コード"
                            width={70}
                            isReadOnly={true}
                            cssClassAll={"read-only-cell"}
                            dataMap={税込区分DataMap}
                            header="込/抜"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="高速料金額"
                            isRequired={false}
                            dataType={wjCore.DataType.Number}
                            header="高速料（税込）"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="高速料記号"
                            cssClassAll={"read-only-cell"}
                            isReadOnly={true}
                            width={100}
                            header="高速料記号"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="備考"
                            width={400}
                            align={"left"}
                            header="請求支払備考(付帯作業内容でも使用)"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            visible={isAGC高速料対象荷主コード}
                            isReadOnly={true}
                            width={120}>
                            <EmptyTextHeader />
                            <wjrGrid.FlexGridCellTemplate
                              cellType={wjrGrid.CellTemplateType.Cell}
                              template={(
                                context: TWijmoCellTemplateContext<T請求支払情報Grid>
                              ) =>
                                context.item.種別 === "請求" ? (
                                  <Button
                                    className="btn btn-small btn-primary move-edit-page"
                                    variant={"caution"}
                                    onClick={AGC高速料Clear}
                                    disabled={wjCore.isNullOrWhiteSpace(
                                      context.item.高速料記号 ?? ""
                                    )}>
                                    記号削除
                                  </Button>
                                ) : (
                                  <></>
                                )
                              }
                            />
                          </wjrGrid.FlexGridColumn>
                        </wjrGrid.FlexGrid>
                      </Col>
                    </Row>
                  </Container>
                  <Container className="register-form mt-3" fluid>
                    <Row>
                      <Col>
                        {id == null && (
                          <Button
                            variant="waiting"
                            className="me-4"
                            disabled={is請求確認済()}
                            onClick={(e) => {
                              beforeSubmit()
                              setIsPageMove(false)
                            }}>
                            続けて登録
                          </Button>
                        )}
                        <Button
                          variant="waiting"
                          disabled={is請求確認済()}
                          onClick={(e) => {
                            beforeSubmit()
                            setIsPageMove(true)
                          }}>
                          {id ? "更新" : "登録して戻る"}
                        </Button>
                        <Button
                          style={{
                            display: id == null ? "none" : "inline-block",
                          }}
                          size="lg"
                          onClick={(e) => {
                            setIsConfirmDeleteModalShow(true)
                          }}
                          className="ms-4"
                          variant="caution">
                          削除
                        </Button>
                        <Button
                          type="button"
                          variant="secondary"
                          className="ms-4"
                          onClick={() => history.goBack()}>
                          一覧に戻る
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      {/* 荷主検索 */}
      <NinusiSeikyuSearchModal
        isShow={is荷主検索Modal}
        setIsShow={setIs荷主検索Modal}
        setNinusi={set荷主ByModal}></NinusiSeikyuSearchModal>
      {/* 乗務員検索 */}
      <ZyomuinSearchModal
        isShow={is乗務員検索Modal}
        setIsShow={setIs乗務員検索Modal}
        setZyomuin={set乗務員ByModal}></ZyomuinSearchModal>
      {/* 受注配車パターン検索 */}
      <ZyutyuHaisyaPatternModal
        isShow={is受注配車パターン検索Modal}
        setIsShow={setIs受注配車パターン検索Modal}
        ninusiCode={モーダル検索用荷主コード}
        ninusiName={モーダル検索用荷主名}
        zyutyubusyo={select受注部所}
        setPattern={(受注配車パターン) => {
          setパターンデータ(受注配車パターン)
        }}></ZyutyuHaisyaPatternModal>
      <TumiOrosiSakiSearchModal
        size="lg"
        ninusiCode={モーダル検索用荷主コード}
        setIsShow={setIs積卸先検索Modal}
        isNinusiReadOnly={true}
        isShow={is積卸先検索Modal}
        setTumiOrosiSaki={(積卸先) => {
          if (選択行 && 選択行.dataItem) {
            cast積卸先(選択行.dataItem, 積卸先)
            積卸flexGrid && createコース編集(積卸flexGrid)
            積卸flexGrid?.refresh()
          }
        }}></TumiOrosiSakiSearchModal>
      {/* 品名検索 */}
      <HinmeiSearchModal
        size="lg"
        setIsShow={setIs品名検索Modal}
        isShow={is品名検索Modal}
        ninusiCode={モーダル検索用荷主コード}
        ninusiName={モーダル検索用荷主名}
        isNinusiReadOnly={true}
        setHinmei={(品名) => {
          if (選択行) {
            const casted: T品名情報Grid = 選択行.dataItem
            cast品名(casted, 品名)
          }
          品名flexGrid?.refresh()
        }}></HinmeiSearchModal>
      {/* 車輌検索 */}
      <SyaryoSearchModal
        setIsShow={(v) => {
          setIs車輌検索Modal(v)
        }}
        isShow={is車輌検索Modal}
        busyoCode={車輌検索用部所コード}
        原動機有無フラグ={車輌検索用原動機有無フラグ}
        setSyaryo={set車輌情報ByModal}></SyaryoSearchModal>
      {/* 傭車検索 */}
      <YosyaSearchModal
        setIsShow={setIs傭車検索Modal}
        isShow={is傭車検索Modal}
        isReadOnly={true}
        yosyaSakiCode={積受注配車傭車会社コード}
        setYosya={set傭車ByModal}></YosyaSearchModal>
      {/* 品名検索 */}
      <AGCKosokuryoSearchModal
        isShow={isAGC高速料検索Modal}
        setIsShow={setIsAGC高速料検索Modal}
        setAGCKosokuryo={(AGC高速料) => {
          const 請求GridData: T請求支払情報Grid[] =
            請求flexGrid?.collectionView.sourceCollection
          const 請求Data = 請求GridData.find((d) => d.種別 === "請求")
          if (請求Data) {
            請求Data.AGC高速料マスタID = AGC高速料.AGC高速料マスタID
            請求Data.高速料記号 = AGC高速料.高速料記号
            // 請求高速料に入れるのは常に税込金額
            請求Data.高速料金額 = AGC高速料.高速料税込

            請求額再計算(請求Data)
            請求flexGrid?.refresh()
          }
        }}></AGCKosokuryoSearchModal>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={() => {
          submit(isPageMove)
        }}>
        入力された内容で{id ? "更新" : "登録"}しますか？
      </ConfirmModal>
      <ConfirmModal
        isShow={isConfirmDeleteModalShow}
        hideHandler={setIsConfirmDeleteModalShow}
        submitHandler={deleteZyutyuHaisya}>
        表示の受注配車情報を削除しますか？
      </ConfirmModal>
    </>
  )
}

export default BunkatuZyutyuHaisyaRegister
